<template>
  <div v-if="testCompleted">
    <!-- 包裹按钮的容器，应用样式使按钮居左 -->
    <div class="restart-test">
      <el-button class="button-background-color" @click="startTest">{{ $t('ProductDiagnosis.restartTest') }}</el-button>
    </div>
    <el-table :header-cell-style="{background:'rgb(250, 250, 250)'}" :data="tableData" style="width: 100%"
              class="table-height">
      <el-table-column :label="$t('ProductDiagnosis.sequenceNumber')" type="index" :min-width="100"></el-table-column>

      <el-table-column :label="$t('ProductDiagnosis.module') " prop="module"></el-table-column>
      <el-table-column :label="$t('ProductDiagnosis.testData')" prop="testData">
        <template v-slot="{ row }">
          <!-- 检查row.testData是否有值并且不是'-'，是则显示值和单位，否则只显示'-' -->
          {{ row.testData && row.testData !== '-' ? `${row.testData} ${unitMapping[row.testContent] || ''}` : '-' }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('ProductDiagnosis.testContent')" prop="testContent"
      ></el-table-column>

      <el-table-column :label="$t('ProductDiagnosis.testResult')">
        <template #default="scope">

          <el-tag
              :type="scope.row.isErrorName === 1 ? 'danger' : scope.row.isErrorName === 2 ? 'warning' : scope.row.isErrorName === 3 ? 'info' : 'success'">
            {{
              scope.row.isErrorName === 1
                  ? $t('ProductDiagnosis.error')
                  : scope.row.isErrorName === 2
                      ? $t('ProductDiagnosis.untested')
                      : scope.row.isErrorName === 3
                          ? $t('ProductDiagnosis.noLight')
                          : $t('ProductDiagnosis.normal')
            }}
          </el-tag>

        </template>
      </el-table-column>

      <el-table-column :label="$t('ProductDiagnosis.helpManual')" prop="manual">
        <template #default="scope">
          <span v-if="scope.row.isErrorName !== 1">-</span>
          <template v-else>
            <a v-if="scope.row.manual_link !== '-'" :href="scope.row.manual_link" target="_blank"
               style="text-decoration: none;color: rgb(0,154,68)">
              {{ scope.row.manual }}
            </a>
            <span v-else>
              {{ scope.row.manual }}
            </span>
          </template>
        </template>
      </el-table-column>

      <template v-slot:empty>
        <EmptySlot/>
      </template>

    </el-table>

  </div>

  <div v-if="!testCompleted " class="dynamic-test-content">
    <div class="device-connection">

      <div v-if="showNoDeviceConnected">
        <img class="device-image" :src="noDeviceConnectImgUrl" width="399"
             height="263.19"
             alt="Device Image"/>
        <p class="no-device-text"> {{ $t('ProductDiagnosis.noDeviceConnected') }}</p>
      </div>

      <div
          v-if="!showNoDeviceConnected && (isMotorConnected || isDisplayConnected) && !testStarted">
        <p style="font-size: 20px;">{{ connectedDevicesDescription }}</p>
        <p style="font-size: 16px;margin-bottom: 40px;">{{ $t('ProductDiagnosis.ensureBatteryOn') }}</p>
        <el-button :class="{ 'custom-button': isStartTestDisabled, 'button-active': !isStartTestDisabled}"
                   @click="startTest" :disabled="isStartTestDisabled"> {{ $t('ProductDiagnosis.startTest') }}
        </el-button>
      </div>

      <div v-if="(isMotorConnected || isDisplayConnected) &&testStarted" class="progress-bar-container">

        <el-steps v-if="activeStep < 2" :active="activeStep" finish-status="success" align-center
                  style="margin-bottom: 20px;">
          <el-step></el-step>
          <el-step></el-step>
        </el-steps>
        <div v-if="activeStep === 0" class="checkbox-container" style="justify-content: center">
          <div v-if="!motorConfigData?.externaldevices">
            <h3>{{ $t('ProductDiagnosis.noPeripheral') }}</h3>
          </div>

          <div v-if="motorConfigData?.externaldevices">
            <el-checkbox-group v-model="checkedList">
              <el-row v-for="device in availableDevices" :key="device">
                <el-checkbox :label="device" :value="device" :disabled="true"></el-checkbox>
              </el-row>
            </el-checkbox-group>
          </div>

          <hr class="dialog-separator-other">
          <div>
            <el-button class="custom-reset-button" @click="cancelTest">{{ $t('ProductDiagnosis.cancel') }}</el-button>
            <el-button class="button-background-color" @click="firstNextStep">{{
                $t('ProductDiagnosis.nextStep')
              }}
            </el-button>
          </div>

        </div>

        <div v-if="activeStep === 1 ">
          <el-table :data="testItems" style="width: 100%" border :show-header="false">
            <el-table-column type="selection" :min-width="10" :max-width="100">
              <template v-slot="scope">
                <el-checkbox v-if="shouldDisplayRow(scope.row)" v-model="scope.row.checked"
                             @change="() => toggleCategory(scope.row)" :disabled="true">
                  {{ scope.row.category }}
                </el-checkbox>
              </template>
            </el-table-column>

            <el-table-column>

              <template v-slot="scope">
                <el-checkbox-group v-model="scope.row.checkedTests">

                  <el-checkbox v-for="item in getFilteredTests(scope.row)" :label="item.label" :key="item.value"
                               :value="item.label" :disabled="true">{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </template>
            </el-table-column>
          </el-table>

          <hr class="dialog-separator-other"/>

          <div>
            <el-button class="custom-reset-button" @click="cancelTest">{{ $t('ProductDiagnosis.cancel') }}</el-button>
            <el-button class="custom-reset-button" @click="previousStep">{{
                $t('ProductDiagnosis.previousStep')
              }}
            </el-button>
            <el-button class="button-background-color" @click="nextStepDebounced">{{
                $t('ProductDiagnosis.nextStep')
              }}
            </el-button>
          </div>
        </div>

        <div v-if="shouldShowTestStep('speedSensorTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>

          <div class="test-step-container">
            <div>
              <img :src="carSpeedImgUrl" :alt="$t('ProductDiagnosis.speedSensorTest')" class="img-size"/>
            </div>

            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.speedSensorTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.rotateCrankForward') }}</div>
              <div class="num-result">
                <div class="right-distance">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span><br>
                  <span v-if="shouldShowSpinner(testResultMessages.M2, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else class="test-num">
                    {{ testResultMessages.M2_data ? `${testResultMessages.M2_data} km/h` : '-' }}
                </span>


                </div>
                <div>
                  <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span><br/>
                  <span v-if="shouldShowSpinner(testResultMessages.M2, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else :class="testResultClass(testResultMessages.M2)">{{ testResultMessages.M2 }}</span>
                </div>
              </div>
            </div>

            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>

          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
          </div>

        </div>

        <div v-if="shouldShowTestStep('cadenceSensorTest')" class="step-same-height">

          <div class="bg-progress">
            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carTaPinImgUrl" :alt="$t('ProductDiagnosis.cadenceSensorTest')" class="img-size"/>
            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.cadenceSensorTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.rotateCrankForward') }}</div>
              <div class="num-result">
                <div class="right-distance">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span><br>
                  <span v-if="shouldShowSpinner(testResultMessages.M3, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else class="test-num">
                    {{ testResultMessages.M3_data ? `${testResultMessages.M3_data} rpm` : '-' }}
                </span>

                </div>
                <div>
                  <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span><br>
                  <span v-if="shouldShowSpinner(testResultMessages.M3, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span
                      v-else :class="testResultClass(testResultMessages.M3)">{{
                      testResultMessages.M3
                    }}</span>
                </div>
              </div>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>

          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if=" shouldShowTestStep('torqueSensorTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carLijuImgUrl" :alt="$t('ProductDiagnosis.otherTorqueSensorTest')" class="img-size"/>

            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.torqueSensorTest') }}
                <el-tooltip effect="dark" placement="top">
                  <template v-slot:content>
                    <div v-html="$t('ProductDiagnosis.sensorTestDescription')"></div>
                  </template>
                  <el-icon class="invert-icon">
                    <QuestionIcon/>
                  </el-icon>
                </el-tooltip>

              </div>
              <div class="test-content">{{ $t('ProductDiagnosis.applyBrakeWhilePedaling') }}</div>
              <div class="num-result">
                <div class="right-distance test-feedback-container">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M6, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else class="test-num">
                    {{ testResultMessages.M6_data ? `${testResultMessages.M6_data} Nm` : '-' }}
                </span>

                </div>
                <div class="test-feedback-container">
                  <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M6, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span
                      v-else
                      :class="testResultClass(testResultMessages.M6)">{{
                      testResultMessages.M6
                    }}</span>
                </div>
              </div>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">
              {{ $t('ProductDiagnosis.cancelTest') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>


        <div v-if="shouldShowTestStep('headlightTest')" class="step-same-height">
          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carBigLightImgUrl" :alt="$t('ProductDiagnosis.headlightTest')" class="img-size"/>
            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.headlightTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.askLightOn') }}</div>
              <div class="top-distance">
                <el-button class="custom-reset-button right-distance"
                           @click="setTestResult(3)">
                  {{ $t('ProductDiagnosis.noLight') }}
                </el-button>
                <!-- 添加灯亮和灯灭按钮 -->
                <el-button class="custom-reset-button right-distance"
                           @click="setTestResult($t('ProductDiagnosis.success'))">
                  {{ $t('ProductDiagnosis.yes') }}
                </el-button>
                <el-button class="custom-reset-button" @click="setTestResult($t('ProductDiagnosis.notPassed'))">
                  {{ $t('ProductDiagnosis.no') }}
                </el-button>
              </div>

            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other">
          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="skipHeadlightTestDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if="shouldShowTestStep('brakeSensorTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carShacheImgUrl" :alt="$t('ProductDiagnosis.brakeSensorTest')" class="img-size"/>

            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.brakeSensorTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.applyBrake') }}</div>
              <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span>&nbsp;&nbsp;&nbsp;
              <span v-if="shouldShowSpinner(testResultMessages.M5, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
              <span
                  v-else :class="testResultClass(testResultMessages.M5)">{{ testResultMessages.M5 }}</span>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if=" shouldShowTestStep('gearSensorTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carWheelImgUrl" :alt="$t('ProductDiagnosis.gearSensorTest')" class="img-size"/>

            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.gearSensorTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.shiftGearsWhileRotatingCrank') }}</div>
              <br>
              <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span><br>
              <span v-if="shouldShowSpinner(testResultMessages.M4, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
              <span
                  v-else :class="testResultClass(testResultMessages.M4)">{{ testResultMessages.M4 }}</span>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if="shouldShowTestStep('throttleSignalTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <img :src="carZhuanbaImgUrl" :alt="$t('ProductDiagnosis.throttleSignalTest')" class="img-size"/>

            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.throttleSignalTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.pullThrottle') }}</div>
              <div class="num-result">
                <div class="right-distance test-feedback-container">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M7, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else class="test-num">
                    {{ testResultMessages.M7_data ? `${testResultMessages.M7_data} V` : '-' }}
                </span>

                </div>
                <div class="test-feedback-container">
                  <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M7, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span
                      v-else :class="testResultClass(testResultMessages.M7)">{{
                      testResultMessages.M7
                    }}</span>
                </div>
              </div>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if="shouldShowTestStep('motorDriveTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>
              <div class="placeholder-text">
                {{ $t('ProductDiagnosis.automaticTestSafetyNotice') }}
              </div>
            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.motorDriveTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.motorDriveTestDescription') }}</div>
              <div class="num-result">
                <div class="right-distance align-num-res">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M9, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span v-else class="test-num" :style="{ color: testResultMessages.M9_data ? 'red' : 'inherit' }">
                    {{ testResultMessages.M9_data ? `Error${testResultMessages.M9_data}` : '-' }}
                </span>

                </div>
                <div>
                  <span class="test-title align-num-res">{{ $t('ProductDiagnosis.testResult') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M9, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span
                      v-else :class="testResultClass(testResultMessages.M9)">{{
                      testResultMessages.M9
                    }}</span>
                </div>
              </div>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>
          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <el-dialog
            :title="$t('ProductDiagnosis.hint')"
            style="text-align: left;"
            v-model="showBatteryCheckModal"
            :width="500"
        >
          <div style="text-align: left">{{ $t('ProductDiagnosis.ensureBatteryOn') }}</div>

          <div class="dialog-footer">
            <el-button class="button-background-color" @click="skipMotorDriveTest">
              {{ $t('ProductDiagnosis.skipMotorDriveTest') }}
            </el-button>
            <el-button class="button-background-color" @click="confirmMotorDriveTest">
              {{ $t('ProductDiagnosis.confirmMotorDriveTest') }}
            </el-button>
          </div>

        </el-dialog>

        <div v-if="shouldShowTestStep('motorTempTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div class="placeholder-text">
              {{ $t('ProductDiagnosis.automaticTestSafetyNotice') }}
            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.motorTempTest') }}</div>
              <div class="num-result">
                <div class="right-distance align-num-res">
                  <span class="test-title">{{ $t('ProductDiagnosis.testValue') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M8, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>

                  <span v-else class="test-num">
                    {{ testResultMessages.M8_data ? `${testResultMessages.M8_data} ℃` : '-' }}
                </span>

                </div>
                <div>
                  <span class="test-title align-num-res">{{ $t('ProductDiagnosis.testResult') }}</span>
                  <span v-if="shouldShowSpinner(testResultMessages.M8, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
                  <span
                      v-else :class="testResultClass(testResultMessages.M8)">{{
                      testResultMessages.M8
                    }}</span>
                </div>
              </div>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>
          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if="shouldShowTestStep('appCommunicationTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <div>

            </div>
            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.appCommunicationTest') }}</div>
              <div class="test-content">{{ $t('ProductDiagnosis.connectApp') }}</div>
              <span class="test-title">{{ $t('ProductDiagnosis.testResult') }}</span>&nbsp;&nbsp;&nbsp;
              <span v-if="shouldShowSpinner(testResultMessages.D2, remainingTime)" class="spinner-container">
  <span class="dot1"></span>
  <span class="dot2"></span>
</span>
              <span v-else
                    :class="testResultClass(testResultMessages.D2)">{{
                  testResultMessages.D2
                }}</span>
            </div>
            <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>

            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>

        <div v-if="shouldShowTestStep('buttonTest')" class="step-same-height">

          <div class="bg-progress">

            <div class="progress-container">
              <div class="step-label">{{ $t('ProductDiagnosis.testStep') }}</div>
              <div class="step-progress">
                <el-progress
                    :percentage="parseFloat(((currentTestStep + 1) / testSteps.length * 100).toFixed(2))"
                    :show-text="false"></el-progress>
              </div>
              <div>{{ (currentTestStep + 1) }} / {{ testSteps.length }}</div>
            </div>

          </div>
          <div class="test-step-container">
            <!-- 当前按钮的图片居左显示 -->
            <div v-if="displayedButtons.length > 0 && displayedButtons[currentButtonIndex]" class="image-container">
              <img :src="displayedButtons[currentButtonIndex].imgUrl"
                   :alt="displayedButtons[currentButtonIndex].name" class="img-size"
                   @error="handleImageError($event, displayedButtons, currentButtonIndex)"/>
            </div>

            <div>
              <div class="main-title">{{ $t('ProductDiagnosis.buttonTest') }}</div>
              <!-- 循环渲染所有按钮 -->
              <div class="buttons-container">
                <div v-for="(button, index) in displayedButtons" :key="`button-${index}`" class="button-item">
                  <div class="button-wrapper">
                    <el-button @click="handleButtonClick(index)" :disabled="displayedButtons.some(btn => btn.status === 'detecting') && displayedButtons[index].status !== 'detecting'" class="custom-reset-button">
                      <img :src="button.imgUrl"
                           :alt="button.name"
                           class="button-icon"
                           @error="handleImageError($event, displayedButtons, index)"/>{{
                        button.name
                      }}
                    </el-button>
                    <!-- 箭头指向当前检测的按钮 -->
                    <div v-if="index === currentButtonIndex && button.status === 'detecting'" class="arrow-indicator">
                      <div class="arrow-text">
                        <span v-if="buttonTestPhase === 'press'">
                          {{ $t('ProductDiagnosis.pressFor5Seconds').replace('+', this.getButtonSymbol(button.name.replace('按键', ''))) }}
                        </span>
                        <span v-else>
                          {{ $t('ProductDiagnosis.releaseButton').replace('+', this.getButtonSymbol(button.name.replace('按键', ''))) }}
                        </span>
                      </div>
                      <div class="arrow-up"></div>
                    </div>
                  </div>
                  <!-- 在此处添加检测状态的逻辑 -->
                  <div v-if="button.status === 'detecting'" class="anjian-detecting">{{
                      $t('ProductDiagnosis.detecting')
                    }}
                  </div>
                  <div v-else-if="button.status === 'passed'" class="anjian-passed">{{
                      $t('ProductDiagnosis.passed')
                    }}
                  </div>
                  <div v-else-if="button.status === 'failed'" class="anjian-failed">{{
                      $t('ProductDiagnosis.notPassed')
                    }}
                  </div>

                  <!-- 为非当前检测项显示待检测状态 -->
                  <div v-else class="anjian-waiting">{{ $t('ProductDiagnosis.waiting') }}</div>
                </div>
              </div>
            </div>
            <!-- 单独渲染当前按钮的图片 -->
            <div class="status-and-timer">
              <el-progress :percentage="remainingTimePercentage" type="circle" :format="formatTime"></el-progress>
            </div>

          </div>
          <hr class="dialog-separator-other"/>

          <div class="button-footer">
            <el-button class="button-background-color" @click="showCancelDialog = true">{{
                $t('ProductDiagnosis.cancelTest')
              }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="completeTest">
              {{ $t('ProductDiagnosis.complete') }}
            </el-button>
            <el-button v-if="isLastStep" class="button-background-color" @click="skipAndComplete">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>
            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.nextStep') }}
            </el-button>

            <el-button v-if="!isLastStep" class="button-background-color" @click="proceedToNextTestStepDebounced">
              {{ $t('ProductDiagnosis.skiptheStep') }}
            </el-button>

          </div>
        </div>
      </div>


    </div>
  </div>

  <!-- 对话框组件，用于确认取消测试 -->
  <el-dialog
      v-model="showCancelDialog"
      :title="$t('ProductDiagnosis.cancelTestTitle')"
      width="500"
      style="text-align: left"
      @close="cancelCancelDialog"
  >
    <span>{{ $t('ProductDiagnosis.cancelTestMessage') }} </span>

    <span class="dialog-footer">
    <el-button @click="showCancelDialog = false" class="custom-reset-button">{{ $t('settingPage.cancel') }}</el-button>
    <el-button class="button-background-color" @click="cancelTest">{{ $t('settingPage.confirm') }}</el-button>
  </span>
  </el-dialog>


</template>

<script>
import EventBus from "@/eventBus";
import {data} from "autoprefixer";
import {getDynamicManualData, getDynamicTestData, recordOperation} from "@/api/api";
import QuestionIcon from "@/components/QuestionIcon.vue";
import EmptySlot from "@/components/EmptySlot.vue";
import dialogMixin from "@/mixins/dialogMixin";

export default {
  mixins: [dialogMixin],
  components: {EmptySlot, QuestionIcon},
  emits: ['complete-test', 'cancel-test', 'start-test', 'update-dynamic-data'],
  data() {
    return {
      showCancelDialog: false, // 控制对话框显示的变量
      carSpeedImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-speed.gif",
      carTaPinImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-tapin.gif",
      carLijuImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-liju.gif",
      carBigLightImgUrl: require("@/assets/image/car-biglight.gif"),
      carShacheImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-shache.gif",
      carWheelImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-wheel.gif",
      carZhuanbaImgUrl: "https://link-public-1310393141.cos.ap-shanghai.myqcloud.com/images/car-zhuanba.gif",

      noDeviceConnectImgUrl: require("@/assets/noDeviceConnect.webp"),

      testStarted: '',
      checkedList: [this.$t('ProductDiagnosis.cadenceSensor'), this.$t('ProductDiagnosis.gearSensor'), this.$t('ProductDiagnosis.brakeSensor'), this.$t('ProductDiagnosis.torqueSensor'), this.$t('ProductDiagnosis.throttle')],

      activeStep: 0,

      motorCheckedList: [],
      dashboardCheckedList: [],
      
      // 缓存变量
      manualDataCache: null,

      testItems: [
        {
          category: this.$t('ProductDiagnosis.motor'),
          checked: false,  // 这里添加了checked属性
          tests: [
            {label: this.$t('ProductDiagnosis.speedSensorTest'), value: 6, id: 'speedSensorTest', itemid: 'M2'},
            {label: this.$t('ProductDiagnosis.cadenceSensorTest'), value: 3, id: 'cadenceSensorTest', itemid: 'M3'},
            {label: this.$t('ProductDiagnosis.torqueSensorTest'), value: 4, id: 'torqueSensorTest', itemid: 'M6'},
            {label: this.$t('ProductDiagnosis.headlightTest'), value: 7, id: 'headlightTest', itemid: 'M1'},
            {label: this.$t('ProductDiagnosis.brakeSensorTest'), value: 2, id: 'brakeSensorTest', itemid: 'M5'},
            {label: this.$t('ProductDiagnosis.gearSensorTest'), value: 1, id: 'gearSensorTest', itemid: 'M4'},
            {label: this.$t('ProductDiagnosis.throttleSignalTest'), value: 5, id: 'throttleSignalTest', itemid: 'M7'},
            {label: this.$t('ProductDiagnosis.motorDriveTest'), value: 8, id: 'motorDriveTest', itemid: 'M9'},
            {label: this.$t('ProductDiagnosis.motorTempTest'), value: 9, id: 'motorTempTest', itemid: 'M8'},
          ],
          checkedTests: [],
        },

        {
          category: this.$t('ProductDiagnosis.display'),
          checked: true,  // 这里添加了checked属性
          tests: [
            {label: this.$t('ProductDiagnosis.buttonTest'), value: 9, id: 'buttonTest', itemid: 'D1'},
          ],
          checkedTests: [],
        },
      ],

      currentTestStep: 0,
      totalTestStep: 10,
      remainingTime: 30, // 剩余时间（秒）
      totalTime: 30, // 用于计算进度条的总时间（秒）
      displayValueToLabelMap: {},

      alwaysShownTests: [6, 7, 8],
      displayAlwaysShownTests: [9],
      testSteps: [], // 动态生成的测试步骤数组
      countdownInterval: null,
      lightResult: null,

      testResultMessages: {}, // 存储每个测试步骤的结果信息

      currentButtonIndex: 0, // 当前测试的按键索引
      isInButtonTest: false, // 新状态，表示是否正在进行按键检测
      buttonTestPhase: 'press', // 按键检测阶段：'press'（按下）、'waiting'（等待5秒）、'release'（松开）
      buttonPressStartTime: null, // 记录按键按下的时间
      buttonTestTimeouts: [], // 存储按键测试的setTimeout ID，用于在点击下一步时清除
      isLastStep: false, // 控制是否为最后一步
      showReportTable: false, // 控制报告表格显示的属性
      // 表格的数据
      tableData: [],
      testCompleted: false, // 本地状态，表明测试是否完成
      showBatteryCheckModal: false, // 新增状态控制电池检查模态框是否显示

      isTesting: false,   // 用于表示测试是否正在进行

      unitMapping: {
        [this.$t('ProductDiagnosis.speedSensorTest')]: 'km/h',
        [this.$t('ProductDiagnosis.cadenceSensorTest')]: 'rpm',
        [this.$t('ProductDiagnosis.torqueSensorTest')]: 'Nm',
        [this.$t('ProductDiagnosis.throttleSignalTest')]: 'V',
        [this.$t('ProductDiagnosis.motorTempTest')]: '℃',
        // 添加其他测试项及其单位
      },
      testResultReceived: false,
      allDevices: [], // 初始化为空数组
      proceedToNextTestStepDebounced: null,
      nextStepDebounced: null,
      isDisplayInfoReceived: false,
      displayedButtonKeys: [], // 存当前应显示的按钮 key
    }
  },
  props: {
    motorTypeAndModelData: Object
  },
  // 使用防抖包装您的函数
  async created() {
    
    this.nextStepDebounced = this.debounce(this.nextStep, 300);
    this.proceedToNextTestStepDebounced = this.debounce(this.proceedToNextTestStep, 300);
    this.skipHeadlightTestDebounced = this.debounce(this.skipHeadlightTest, 300);
    
    this.initializeAllDevices();
    
    this.initializeTestItems();
    
    // 改为非阻塞调用，避免阻塞组件初始化
    this.loadSubPermissions().catch(error => {
      console.error('loadSubPermissions错误:', error);
    }).finally(() => {
    });
    
  },
  watch: {
    // 监听语言变化并更新 availableDevices
    '$i18n.locale': function () {
      this.initializeAllDevices();
      this.initializeTestItems(); // 语言切换时重新初始化测试项目
      this.generateTestSteps(); // 确保生成的测试步骤也是最新的
    },
    isDisplayConnected(newValue) {
      if (newValue) {
        this.initializeTestItems();
      }
    },
    motorConfigData: {
      handler(newVal) {
        if (newVal && newVal.externaldevices) {
          this.initializeAllDevices();
        }
      },
      deep: true,  // 深度监听对象内部变化
      immediate: true  // 立即执行一次，确保初始加载也被处理
    },
  },

  mounted() {
    
    //用于点击重新连接清空数据
    EventBus.on('reset-all-data', this.clearData);

    EventBus.on('DisplayInfoResponse', this.handleDisplayInfoResponse);

    // 假设您有一个数组定义了所有的 itemid
    const testItemIds = ["M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9"];

    // 为每个测试项设置监听器
    testItemIds.forEach((itemid) => {
      EventBus.on(`DeviceTest_${itemid}`, this.handleGenericTestResponse);
    });

    EventBus.on('DeviceTestCancelReceived', this.handleTestCancelResponse);
    EventBus.on('OpenLightResponse', this.handleOpenLightResponse);
    EventBus.on('CloseLightResponse', this.handleCloseLightResponse);
    EventBus.on('DeviceTest_D1', this.handleDashboardTestD1);
    EventBus.on('startMotorAutoTestResponse', this.handleStartMotorAutoTestResponse);
    EventBus.on('RealTimeWsMessage', this.handleStopMotorTestResponse);
    EventBus.on('request-stop-test', this.handleStopTestRequest);
    // 假设您有一个数组定义了所有的 itemid
    const generalDashboardTestItemIds = ["D3", "D4"]; // 扩展此数组以包含未来的指令，D1由专门的handleDashboardTestD1处理

    // 为每个测试项设置监听器
    generalDashboardTestItemIds.forEach((itemid) => {
      EventBus.on(`DeviceTest_${itemid}`, this.handleDashboardTestDx);
    });

    // 设置默认进入时第一个按键为当前检测按键
    this.currentButtonIndex = 0;

    // 可能需要手动触发视图更新
    this.$forceUpdate();
    

  },
  beforeUnmount() {
    //用于点击重新连接清空数据
    EventBus.off('reset-all-data', this.clearData);

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    // 清除按键松开定时器
    if (this.buttonReleaseTimeout) {
      clearTimeout(this.buttonReleaseTimeout);
    }
    // 在组件销毁时移除监听器，避免内存泄露
    const testItemIds = ["M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9"];

    testItemIds.forEach((itemid) => {
      EventBus.off(`DeviceTest_${itemid}`, this.handleGenericTestResponse);
    });

    EventBus.off('DeviceTestCancelReceived', this.handleTestCancelResponse);
    EventBus.off('OpenLightResponse', this.handleOpenLightResponse);
    EventBus.off('CloseLightResponse', this.handleCloseLightResponse);
    EventBus.off('DisplayInfoResponse', this.handleDisplayInfoResponse);
    EventBus.off('DeviceTest_D1', this.handleDashboardTestD1);

    EventBus.off('startMotorAutoTestResponse', this.handleStartMotorAutoTestResponse);
    EventBus.off('RealTimeWsMessage', this.handleStopMotorTestResponse);

    const generalDashboardTestItemIds = ["D3", "D4"];

    generalDashboardTestItemIds.forEach((itemid) => {
      EventBus.off(`DeviceTest_${itemid}`, this.handleDashboardTestDx);
    });
    EventBus.off('request-stop-test', this.handleStopTestRequest);
  },
  computed: {
    getMotorTypeAndModelData() {
      const {isMotorConnected, isMotorConnecting, motorTypeAndModelData} = this;
      if (isMotorConnected && !isMotorConnecting && motorTypeAndModelData) {
        // 电机在线且数据存在，直接返回数据
        return motorTypeAndModelData;
      }
      // 电机未在线或数据不存在，返回带有默认值的对象
      return {
        motorType: null, // 或者其他适当的默认值，比如 'unknown'
        model: '-' // 默认值，表示模型未获取或电机未在线
      };
    },
    stepCommands() {
      return {
        [this.$t('ProductDiagnosis.speedSensorTest')]: {
          cmd: "DeviceTest",
          itemid: "M2",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.gearSensorTest')]: {
          cmd: "DeviceTest",
          itemid: "M4",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.brakeSensorTest')]: {
          cmd: "DeviceTest",
          itemid: "M5",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.cadenceSensorTest')]: {
          cmd: "DeviceTest",
          itemid: "M3",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.throttleSignalTest')]: {
          cmd: "DeviceTest",
          itemid: "M7",
          itemname: "",
          p1: "1",
          p2: "5",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.torqueSensorTest')]: {
          cmd: "DeviceTest",
          itemid: "M6",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.headlightTest')]: {cmd: "openLight", param: "", itemid: "M1",},
        [this.$t('ProductDiagnosis.motorDriveTest')]: {
          cmd: "DeviceTest",
          itemid: "M9",
          itemname: "",
          p1: "1",
          p2: "100",
          maxTestCount: "50"
        },
        [this.$t('ProductDiagnosis.motorTempTest')]: {
          cmd: "DeviceTest",
          itemid: "M8",
          itemname: "",
          p1: "1",
          p2: "150",
          maxTestCount: "50"
        },

        [this.$t('ProductDiagnosis.buttonTest')]: {
          cmd: "DeviceTest",
          itemid: "D1",
          itemname: "",
          p1: "1",
          p2: "",
          maxTestCount: "15"
        }
      };
    },
    availableDevices() {
      return this.allDevices;
    },
    showNoDeviceConnected() {

      // 所有设备都未成功连接
      const allDevicesNotConnected = !this.isMotorConnected && !this.isBatteryConnected && !this.isDisplayConnected;
      // 所有设备都在尝试连接
      const allDevicesConnecting = this.isMotorConnecting && this.isBatteryConnecting && this.isDisplayConnecting;

      // 如果所有设备都在连接中，或者都未连接，则返回true
      return allDevicesNotConnected || allDevicesConnecting;
    },
    connectedDevicesDescription() {
      let descriptions = [];
      if (this.isMotorConnected) descriptions.push(this.$t('ProductDiagnosis.motor'));
      if (this.isBatteryConnected) descriptions.push(this.$t('ProductDiagnosis.battery'));
      if (this.isDisplayConnected) descriptions.push(this.$t('ProductDiagnosis.dashboard'));

      return descriptions.length > 0
          ? `${this.$t('ProductDiagnosis.system')} ${this.$t('ProductDiagnosis.testReady')}`
          : this.$t('ProductDiagnosis.connectDevice');
    },
    isStartTestDisabled() {
      // 检查电机或仪表是否连接，并且检查任何设备是否在连接中
      return !(this.isMotorConnected || this.isDisplayConnected) || this.isBatteryConnecting || this.isMotorConnecting || this.isDisplayConnecting;
    },
    isBatteryConnected() {
      if (!this.batteryInfo) {
        return false; // 如果是，认为"电池信息为空"
      }
      return Object.keys(this.batteryInfo).length !== 0;
    },
    batteryInfo() {
      return this.$store.state.batteryInfo;
    },
    // 添加一个计算属性来过滤出需要显示的按钮
    displayedButtons() {
      // 只显示仪表返回的那些按钮，顺序与 displayedButtonKeys 一致
      const buttons = this.displayedButtonKeys.map(key => this.buttonTests.find(btn => btn.key === key)).filter(Boolean);
      // 过滤掉p1为1的电源键
      return buttons.filter(btn => btn.p1 !== '1');
    },

    displayedButtonsJson() {
      return JSON.stringify(this.displayedButtons, null, 2);
    },

    data() {
      return data
    },

    remainingTimePercentage() {
      if (this.totalTime <= 0) {
        return 0;
      }
      return (this.remainingTime / this.totalTime) * 100;
    },
    isDisplayConnected() {
      return this.$store.state.isDisplayConnected;
    },
    isMotorConnected() {
      return this.$store.state.isMotorConnected;
    },
    isMotorConnecting() {
      return this.$store.state.isMotorConnecting;
    },
    isBatteryConnecting() {
      return this.$store.state.isBatteryConnecting;
    },
    isDisplayConnecting() {
      return this.$store.state.isDisplayConnecting;
    },
    motorConfigData() {
      return this.$store.state.motorConfigData;
    },
    getWs() {
      return this.$store.state.ws;
    },
    buttonTests() {
      // 动态生成按钮列表，名称随语言切换
      return [
        {
          key: 'powerButton',
          name: this.$t('ProductDiagnosis.powerButton'),
          imgUrl: require("@/assets/image/car-dy.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '1'
        },
        {
          key: 'incrementButton',
          name: this.$t('ProductDiagnosis.incrementButton'),
          imgUrl: require("@/assets/image/car-jia.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '2'
        },
        {
          key: 'decrementButton',
          name: this.$t('ProductDiagnosis.decrementButton'),
          imgUrl: require("@/assets/image/car-jian.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '3'
        },
        {
          key: 'walkButton',
          name: this.$t('ProductDiagnosis.walkButton'),
          imgUrl: require("@/assets/image/car-tx.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '6'
        },
        {
          key: 'headlightButton',
          name: this.$t('ProductDiagnosis.headlightButton'),
          imgUrl: require("@/assets/image/car-biglight.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '7'
        },
        {
          key: 'modeButton',
          name: this.$t('ProductDiagnosis.modeButton'),
          imgUrl: require("@/assets/image/car-i.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '4'
        },
        {
          key: 'iButton',
          name: this.$t('ProductDiagnosis.iButton'),
          imgUrl: require("@/assets/image/car-i.gif"),
          status: 'waiting',
          shouldBeDisplayed: false,
          p1: '5'
        },
      ];
    },
  },

  methods: {
    handleStopTestRequest(shouldStop) {
      if (shouldStop) {
        this.cancelTest();
      }
    },
    getButtonSymbol(buttonName) {
      if (buttonName === '加' || buttonName.includes('Increment')) {
        return '+';
      } else if (buttonName === '减' || buttonName.includes('Decrement')) {
        return '-';
      }
      return buttonName;
    },
    getValueToLabelMap() {
      return {
        '3': this.$t('ProductDiagnosis.cadenceSensor'),
        '1': this.$t('ProductDiagnosis.gearSensor'),
        '2': this.$t('ProductDiagnosis.brakeSensor'),
        '4': this.$t('ProductDiagnosis.torqueSensor'),
        '5': this.$t('ProductDiagnosis.throttle'),
        '9': this.$t('ProductDiagnosis.buttonTest')
      };
    },

    // 处理图片加载失败 - 尽量重试加载原图片
    handleImageError(event, buttonsArray, index) {
      if (!event.target || !buttonsArray || !buttonsArray[index]) {
        return;
      }
      
      const button = buttonsArray[index];
      const originalSrc = button.imgUrl;
      const imgElement = event.target;
      
      // 如果已经重试过，不要再重试
      if (imgElement.dataset.retried) {
        return;
      }
      
      // 标记为已重试
      imgElement.dataset.retried = 'true';
      
      // 确保originalSrc是字符串
      if (typeof originalSrc !== 'string') {
        return;
      }
      
      // 尝试重试加载原图片，增加缓存随机参数
      const retrySrc = `${originalSrc}?t=${new Date().getTime()}`;
      
      // 使用setTimeout延迟重试，避免立即重试导致的连续失败
      setTimeout(() => {
        imgElement.src = retrySrc;
      }, 100);
    },

    async fetchThresholdsForSteps(steps) {
      try {
        const itemnames = steps.map(step => step.stepName);
        const thresholdsData = await getDynamicTestData(itemnames);

        // 假设返回数据是一个数组，键为 itemname，值为对应的阈值
        let thresholdsMap = {};
        if (Array.isArray(thresholdsData.data)) {
          thresholdsData.data.forEach(data => {
            // 假设 thresholds 是一个数组，我们取第一个值
            if (data.thresholds && data.thresholds.length > 0) {
              thresholdsMap[data.name] = {
                begin: data.thresholds[0].begin,
                end: data.thresholds[0].end
              };
            }
          });
        }
        return thresholdsMap;
      } catch (error) {
        return {};
      }
    },

    async updateStepCommands() {
      try {
        // 检查组件是否已销毁
        if (typeof this.$t !== 'function') {
          return;
        }
        
        // 收集所有的 stepNames
        const steps = Object.keys(this.stepCommands).map(stepName => ({
          stepName,
          command: this.stepCommands[stepName]
        }));

        // 调用新的 API 方法获取所有阈值
        const thresholdsMap = await this.fetchThresholdsForSteps(steps);

        // 更新每个 command 的阈值
        for (let stepName in this.stepCommands) {
          const command = this.stepCommands[stepName];
          const stepThresholds = thresholdsMap[stepName];

          // 跳过 buttonTest，因为它的 p1 值应该在 handleButtonClick 中动态设置
          if (stepName === this.$t('ProductDiagnosis.buttonTest')) {
            continue;
          }

          if (command && stepThresholds) {
            command.p1 = String(stepThresholds.begin); // 转换为字符串
            command.p2 = String(stepThresholds.end);   // 转换为字符串
          }
        }
      } catch (error) {
        // 捕获错误并忽略，防止组件销毁后执行导致的错误
        console.error('updateStepCommands error:', error);
        return;
      }
    },

    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this, args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    initializeAllDevices() {
      if (this.motorConfigData && this.motorConfigData.externaldevices) {
        this.allDevices = this.motorConfigData.externaldevices.map(code => this.deviceName(code));
      }
    },
    clearData() {
      if (!this.isTesting) {
        this.tableData = [];
        // 清空其他可能影响设备连接状态的数据
        this.isMotorConnected = false;
        this.isBatteryConnected = false;
        this.isDisplayConnected = false;
        this.showNoDeviceConnected = true;  // 立即显示无设备连接界面
        this.testCompleted = false;
      }
    },
    handleStopMotorTestResponse(response) {
      if (response.code !== 200) {
        console.error("Failed to stop motor test:", response.error);
      }
    },

    handleStartMotorAutoTestResponse(response) {
      if (response.code === 200) {
        const testCommand = this.stepCommands[this.$t('ProductDiagnosis.motorDriveTest')]; // 直接引用 stepCommands 中的命令配置
        if (testCommand) {
          this.sendCommand(testCommand);
        } else {
          console.error("Test command for motor auto test not found in stepCommands.");
        }
      } else {
        console.error("Failed to start motor auto test:", response.error);
      }
    },


    // 用户选择跳过测试
    skipMotorDriveTest() {
      this.showBatteryCheckModal = false; // 关闭模态框
      this.testResultMessages['M9'] = this.$t('ProductDiagnosis.untested');
      this.startCountdown(); // 重新启动倒计时
      // 判断是否已经在测试的最后一步
      if (this.currentTestStep >= this.testSteps.length - 1) {
        this.completeTest(); // 假设这个方法负责处理测试完成的逻辑
      } else {
        // 如果不是最后一步，继续到下一个测试步骤
        // 获取下一个测试步骤的名称
        const nextStepName = this.testSteps[this.currentTestStep + 1]?.name;
        this.continueToNextTestStep(nextStepName);
      }
    },

    // 用户确认电量充足，准备进行测试
    confirmMotorDriveTest() {
      this.showBatteryCheckModal = false; // 关闭模态框
      this.startCountdown(); // 重新启动倒计时
      this.proceedToMotorDriveTest(); // 进行电机驱动测试
    },

    proceedToMotorDriveTest() {
      const startTestCommand = {cmd: "startMotorAutoTest", "param": ""};

      // 发送开始测试命令
      this.sendCommand(startTestCommand);
    },

    async saveTestResults() {
      const currentLanguage = this.$store.getters.currentLanguage; // 获取当前语言
      // 清空表格数据
      this.tableData = [];

      // 测试内容与中文名称的映射表
      const itemNameMappingResult = {
        'M1': this.$t('ProductDiagnosis.headlightTest'),
        'M2': this.$t('ProductDiagnosis.speedSensorTest'),
        'M4': this.$t('ProductDiagnosis.gearSensorTest'),
        'M5': this.$t('ProductDiagnosis.brakeSensorTest'),
        'M3': this.$t('ProductDiagnosis.cadenceSensorTest'),
        'M7': this.$t('ProductDiagnosis.throttleSignalTest'),
        'M6': this.$t('ProductDiagnosis.torqueSensorTest'),
        'M9': this.$t('ProductDiagnosis.motorDriveTest'),
        'M8': this.$t('ProductDiagnosis.motorTempTest'),
        'D1': this.$t('ProductDiagnosis.buttonTest'),
      };
      const itemNameMapping = {
        'M1': '大灯检测',
        'M2': '车速传感器检测',
        'M4': '齿轮传感器检测',
        'M5': '刹车传感器检测',
        'M3': '踏频传感器检测',
        'M7': '转把信号检测',
        'M6': '动态力矩检测',
        'M9': '电机驱动检测',
        'M8': '电机温度检测',
        'D1': '按键检测',
      };

      // 手册数据将在后续异步加载

      let resultsArray = [];
      let index = 0;

      // 合并按键检测结果
      // buttonTestResults变量已移除，直接使用testResultMessages['D1']判断是否显示按键检测结果

      for (const key in this.testResultMessages) {
        if (!key.endsWith('_data')) {
          // 提取数据
          let testContent = key; // 测试名称
          let result = this.testResultMessages[key]; // 测试结果
          // 如果测试结果为空，并且不是D1（按键测试），则设置为未测试
          if (!result) {
            result = key === 'D1' ? this.$t('ProductDiagnosis.notPassed') : this.$t('ProductDiagnosis.untested');
          }

          let testDataKey = `${key}_data`; // 测试数据的键名
          let testData = this.testResultMessages[testDataKey] || '-'; // 测试数据

          let itemname = itemNameMapping[testContent] || '';
          let internationalizedItemname = itemNameMappingResult[testContent] || '';

          let type = testContent.startsWith('M') ? 0 : testContent.startsWith('D') ? 1 : undefined;

          // 暂时使用默认手册值，后续会异步更新
          let manual = '-'; // 默认值
          let manual_link = ''; // 默认链接

          // 构建用于表格显示的对象
          let isErrorName;
          if (testContent === 'M1') {
            // 根据lightResult确定大灯检测项M1的测试结果
            //isErrorName = this.lightResult === this.$t('ProductDiagnosis.success') ? 0 : 1;

            // 根据lightResult确定大灯检测项M1的测试结果
            if (this.lightResult === 3) {
              isErrorName = 3; // 3代表"没灯"
            } else if (this.lightResult === this.$t('ProductDiagnosis.success')) {
              isErrorName = 0; // 正常
            } else if (this.lightResult === null) {
              isErrorName = 2; // 未测试
            } else {
              isErrorName = 1; // 异常
            }
          } else {
            // 其他测试内容的测试结果
            isErrorName = result === this.$t('ProductDiagnosis.passed') ? 0 : result === this.$t('ProductDiagnosis.untested') ? 2 : 1;
          }

          // 处理按键测试的逻辑已移至saveTestResults方法的后续部分
          if (testContent !== 'D1') {
            if (internationalizedItemname) { // 仅当测试内容有对应名称时才添加
              // 构建用于表格显示的对象
              resultsArray.push({
                index: ++index,
                module: type === 0 ? this.$t('ProductDiagnosis.motor') : type === 1 ? this.$t('ProductDiagnosis.dashboard') : this.$t('ProductDiagnosis.unknown'),
                testData: testData,
                testContent: internationalizedItemname,
                isErrorName: isErrorName,
                measures: this.$t('ProductDiagnosis.referenceHelpManual'),
                manual: manual,
                manual_link: manual_link,
                // 保存原始数据用于后续更新手册信息
                originalKey: key,
                originalType: type,
                originalItemname: itemname
              });
            }
          }

        }
      }

      
      // 检查是否存在D1按键检测结果
      
      // 将按键检测结果合并到一个对象中
      if (Object.prototype.hasOwnProperty.call(this.testResultMessages, 'D1')) {
        // 获取所有非电源键的按钮
        const nonPowerButtons = this.displayedButtons.filter(button => button.p1 !== '1');
        // 找出所有未通过测试的按钮
        const failedButtons = nonPowerButtons.filter(button => {
          const buttonResult = this.testResultMessages[button.name];
          return buttonResult === this.$t('ProductDiagnosis.notPassed');
        }).map(button => button.name).join(', ');

        // 暂时使用默认手册值，后续会异步更新
        let manual = '-'; // 默认值
        let manual_link = ''; // 默认链接

        let buttonIsErrorName;
        const d1Result = this.testResultMessages['D1'];

        if (d1Result === this.$t('ProductDiagnosis.untested')) {
          buttonIsErrorName = 2; // 未测试
        } else {
          // 根据D1的实际测试结果设置状态
          buttonIsErrorName = d1Result === this.$t('ProductDiagnosis.passed') ? 0 : 1;
        }

        const buttonTestResult = {
          index: ++index,
          module: this.$t('ProductDiagnosis.dashboard'),
          testData: failedButtons || '-',
          testContent: this.$t('ProductDiagnosis.buttonTest'),
          isErrorName: buttonIsErrorName,
          measures: this.$t('ProductDiagnosis.referenceHelpManual'),
          manual: manual,
          manual_link: manual_link,
          // 保存原始数据用于后续更新手册信息
          originalKey: 'D1',
          originalType: 1,
          originalItemname: '按键检测'
        };
        
        resultsArray.push(buttonTestResult);
      }

      
      // 清空tableData
      this.tableData = [];
      
      // 一次性加载所有数据到tableData，减少DOM更新次数
      // 直接一次性加载所有数据
      this.tableData = [...resultsArray];
      
      
      // 确保所有数据都已加载到tableData后再触发事件
      await this.$nextTick();
      
      this.$emit('update-dynamic-data', this.tableData);

      // 异步加载手册数据并更新表格
      this.loadManualDataAndUpdateTable(currentLanguage);
    },
    
    async loadManualDataAndUpdateTable(currentLanguage) {
      // 获取所有动态测试项的操作手册数据（使用缓存）
      let manualData = [];
      try {
        // 检查是否有缓存的手册数据
        if (this.manualDataCache) {
          manualData = this.manualDataCache;
        } else {
          // 从API获取数据
          const response = await getDynamicManualData(1, 100);
          manualData = response.data;
          // 将数据缓存起来
          this.manualDataCache = manualData;
        }
      } catch (error) {
        return;
      }

      // 如果没有表格数据，直接返回
      if (this.tableData.length === 0) {
        return;
      }

      // 更新表格中的手册信息
      const updatedTableData = this.tableData.map(item => {
        // 匹配操作手册数据
        const manualInfo = manualData.find(manualItem => 
          manualItem.product_type === item.originalType && 
          manualItem.name === item.originalItemname
        ) || {};

        let manual = '-'; // 默认值
        let manual_link = ''; // 默认链接

        if (manualInfo && manualInfo.documents) {
          let motor_type = 0;
          if (this.motorTypeAndModelData?.motorType === 'hub') {
            motor_type = 1;
          }
          const document = manualInfo.documents.find(
              doc => doc.lang === currentLanguage && doc.type === motor_type
          ) || manualInfo.documents[0];

          if (manualInfo.document_type === 1) {
            // 如果 document_type 为 1，使用 content 作为手册内容
            manual = document.content || '-';
            manual_link = '-'; // 文本类型不提供链接
          } else if (manualInfo.document_type === 0) {
            // 如果 document_type 为 0，使用文件名和链接
            manual = document.file_name || '-';
            manual_link = document.fileUrl || '-';
          }
        }

        // 返回更新后的项目
        return {
          ...item,
          manual,
          manual_link
        };
      });

      // 更新表格数据
      this.tableData = updatedTableData;
      await this.$nextTick();
      
      // 再次触发更新事件
      this.$emit('update-dynamic-data', this.tableData);
    },

    handleDashboardTestDx(message) {
      const data = this.safeJSONParse(message.data);
      // D1事件由专门的handleDashboardTestD1处理，这里跳过
      if (data.itemid === "D1") {
        return;
      }
      
      // 如果测试结果已经是未测试，不处理服务器响应
      if (this.testResultMessages[data.itemid] === this.$t('ProductDiagnosis.untested')) {
        return;
      }
      
      // 检查result是否为true（考虑字符串和布尔值两种情况）
      const isResultTrue = data.result === true || data.result === 'true';
      
      // 如果result为true，则处理data.data
      if (isResultTrue) {
        // 将测试结果更新为"通过"，同时存储data.data的值
        this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.passed');
        // 例如，将data.data存储为新的键值对，键名可以根据需要定义，如`${data.itemid}-data`
        this.testResultMessages[`${data.itemid}_data`] = data.data;
      } else {
        // 如果result不为true，检查是否是取消测试的情况
        if (data.data === 'Test canceled') {
          // 对于APP通讯检测(D2)，取消测试应视为未通过，而不是未测试
          if (data.itemid === 'D2') {
            this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.notPassed');
          } else {
            this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.untested');
          }
        } else {
          // 如果不是取消测试，则更新为"不通过"
          this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.notPassed');
        }
        this.testResultMessages[`${data.itemid}_data`] = '';
      }
    },

    handleDashboardTestD1(message) {
      // 如果测试已经取消或未开始，不处理设备返回的测试结果
      if (!this.isTesting) {
        return;
      }
      
      const data = this.safeJSONParse(message.data);
      if (data.itemid !== "D1") {
        return;
      }
      // 确定当前正在测试的按钮
      const currentButton = this.displayedButtons[this.currentButtonIndex];

      if (!currentButton) {
        console.error("No current button found for testing.");
        return;
      }

      // 如果当前按钮是电源键（p1为1），则跳过处理
      if (currentButton.p1 === '1') {
        return;
      }
      
      // 如果当前按钮的状态不是detecting，说明测试已经被跳过或重置，不处理测试结果
      if (currentButton.status !== 'detecting') {
        return;
      }

      // 根据按键检测阶段处理结果
      if (this.buttonTestPhase === 'press') {
        // 第一阶段：检测按键是否被按下
        // 如果按下指令返回false，则不发送松开指令，直接标记测试失败
        if (data.result === 'false') {
          // 按键按下测试失败，直接标记结果为不通过
          currentButton.status = 'failed';
          this.testResultMessages[currentButton.name] = this.$t('ProductDiagnosis.notPassed');
          // 直接进入下一个按键测试，不等待
          // 先记录当前按钮索引
          const currentIndex = this.currentButtonIndex;
          // 移动到下一个按钮索引
          this.moveToNextButton();
          // 检查是否真的移动到了新的索引位置
          if (this.currentButtonIndex > currentIndex && this.currentButtonIndex < this.displayedButtons.length) {
            // 如果确实移动到了新的索引位置（即不是最后一个按钮），手动调用handleButtonClick开始测试
            this.handleButtonClick(this.currentButtonIndex);
          }
        } else {
          // 按下指令返回true，进入松开检测阶段
          this.buttonTestPhase = 'release';
          // 记录按下时间
          this.buttonPressStartTime = Date.now();
          // 发送松开指令（p2=0）
          const command = {
            "cmd": "DeviceTest",
            "itemid": "D1",
            "itemname": currentButton.p1,
            "p1": currentButton.p1,
            "p2": "0", // 第二阶段：松开
            "maxTestCount": "30"
          };
          this.sendCommand(command);
        }
      } else if (this.buttonTestPhase === 'release') {
        // 第二阶段：检测按键是否已松开
        if (data.result === 'true' && data.p2 === "0" && data.p1 === currentButton.p1) {
          // 按键已正确松开，测试通过
          currentButton.status = 'passed';
          this.testResultMessages[currentButton.name] = this.$t('ProductDiagnosis.passed');
        } else {
          // 按键未正确松开或响应无效，测试失败
          currentButton.status = 'failed';
          this.testResultMessages[currentButton.name] = this.$t('ProductDiagnosis.notPassed');
        }
        // 直接处理下一个按钮，不等待
        // 先记录当前按钮索引
        const currentIndex = this.currentButtonIndex;
        // 移动到下一个按钮索引
        this.moveToNextButton();
        // 检查是否真的移动到了新的索引位置
        if (this.currentButtonIndex > currentIndex && this.currentButtonIndex < this.displayedButtons.length) {
          // 如果确实移动到了新的索引位置（即不是最后一个按钮），手动调用handleButtonClick开始测试
          // 这样确保只有在收到当前按键的完整响应后，才会开始下一个按键的测试
          this.handleButtonClick(this.currentButtonIndex);
        }
      }

      // 可能需要通知Vue强制更新视图，特别是如果使用了对象或数组的索引直接修改数据时
      this.$forceUpdate();
    },

    moveToNextButton() {
      // 如果测试已经取消或未开始，不处理按键测试的状态
      if (!this.isTesting) {
        return;
      }
      
      // 清除按键松开定时器
      if (this.buttonReleaseTimeout) {
        clearTimeout(this.buttonReleaseTimeout);
        this.buttonReleaseTimeout = null;
      }
      // 检查是否还有下一个按钮需要测试
      if (this.currentButtonIndex < this.displayedButtons.length - 1) {
        // 非最后一个按钮：清除当前倒计时，确保切换按键时倒计时不会继续运行
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
        // 移动到下一个按钮索引
        this.currentButtonIndex++;
      } else {
        // 最后一个按钮：结束按键测试阶段，但不清除倒计时，让它继续走完
        this.buttonTestPhase = 'press';
        // 确保当前按钮索引不超出范围
        this.currentButtonIndex = this.displayedButtons.length - 1;
        // 计算按键测试的总结果
        let allButtonsPassed = true;
        for (const button of this.displayedButtons) {
          // 跳过电源键
          if (button.p1 === '1') {
            continue;
          }
          // 检查按钮是否通过测试
          const buttonResult = this.testResultMessages[button.name];
          if (buttonResult === this.$t('ProductDiagnosis.notPassed') || !buttonResult) {
            allButtonsPassed = false;
            break;
          }
        }
        // 设置按键测试的总结果
        this.testResultMessages['D1'] = allButtonsPassed ? this.$t('ProductDiagnosis.passed') : this.$t('ProductDiagnosis.notPassed');
        // 不自动调用proceedToNextTestStep()，等待倒计时结束自动处理
        // 设置isInButtonTest为false，允许用户复测任何按键
        this.isInButtonTest = false;
      }
    },

    handleDisplayInfoResponse(response) {
      this.isDisplayInfoReceived = true; // 标记已接收到显示信息
      let displayInfo; // 将displayInfo声明在函数顶部

      if (response && response.data) {
        try {
          displayInfo = JSON.parse(response.data); // 为displayInfo赋值
        } catch (e) {
          console.error('Failed to parse JSON data:', e);
          return; // 如果解析失败，直接返回以防止后续代码执行
        }
      }
      const keyToButtonNameMap = {
        1: this.$t('ProductDiagnosis.powerButton'),
        2: this.$t('ProductDiagnosis.incrementButton'),
        3: this.$t('ProductDiagnosis.decrementButton'),
        4: this.$t('ProductDiagnosis.modeButton'),
        5: this.$t('ProductDiagnosis.iButton'),
        6: this.$t('ProductDiagnosis.walkButton'),
        7: this.$t('ProductDiagnosis.headlightButton'),
      };

      // 确保displayInfo已定义并且是对象
      if (displayInfo) {
        this.buttonTests.forEach(button => {
          button.shouldBeDisplayed = false; // 默认设置为不显示
        });

        // 根据Numberofkeys的值和KeyXvalue更新显示的按钮
        for (let i = 1; i <= 10; i++) {
          const keyValue = displayInfo[`Key${i}value`];
          if (keyValue === 0) {
            continue; // 如果 keyValue 未定义，则跳过当前循环
          }
          // 如果Key1value为1（电源键），则跳过，不显示
          if (keyValue === 1) {
            continue;
          }
          const buttonName = keyToButtonNameMap[keyValue];
          if (buttonName) {
            const button = this.buttonTests.find(button => button.name === buttonName);
            if (button) {
              button.shouldBeDisplayed = true;
            }
          }
        }
      }
      // 动态生成 displayedButtonKeys
      const keys = [];
      if (displayInfo) {
        const keyMap = {
          1: 'powerButton',
          2: 'incrementButton',
          3: 'decrementButton',
          4: 'modeButton',
          5: 'iButton',
          6: 'walkButton',
          7: 'headlightButton'
        };
        for (let i = 1; i <= 10; i++) {
          const keyValue = displayInfo[`Key${i}value`];
          if (!keyValue) continue;
          // 如果keyValue为1（电源键），则跳过
          if (keyValue === 1) continue;
          const btnKey = keyMap[keyValue];
          if (btnKey && !keys.includes(btnKey)) {
            keys.push(btnKey);
          }
        }
      }
      this.displayedButtonKeys = keys;
    },

    async completeTest() {
      
      // 直接从当前测试步骤获取 itemid
      const currentItemId = this.testSteps[this.currentTestStep]?.id;
      if (currentItemId === "motorDriveTest") {
        const stopTestCommand = {cmd: "stopMotorTest", param: ""};
        this.sendCommand(stopTestCommand);
      }
      
      // 获取当前测试步骤的itemid
      const currentTestItemId = this.testSteps[this.currentTestStep]?.command?.itemid;
      
      // 无论哪个测试步骤是最后一个，都发送取消当前测试步骤的指令
      if (currentTestItemId) {
        this.sendCommand({
          cmd: "DeviceTestCancel",
          param: currentTestItemId
        });
      }
      
      clearInterval(this.countdownInterval); // 停止倒计时
      // 重置倒计时时间，避免重新测试时显示0秒
      this.totalTime = 0;
      this.remainingTime = 0;
      
      // 如果当前是按键测试步骤，计算并设置D1的测试结果
      if (currentTestItemId === "D1") {
        
          // 清除所有按键测试的setTimeout
          if (this.buttonTestTimeouts && this.buttonTestTimeouts.length > 0) {
            this.buttonTestTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
            this.buttonTestTimeouts = [];
          }
          
          // 如果D1的测试结果已经是未测试，则不再重新计算
          if (this.testResultMessages['D1'] !== this.$t('ProductDiagnosis.untested')) {
            // 计算并设置D1的测试结果
            const nonPowerButtons = this.displayedButtons.filter(button => button.p1 !== '1');
            
            let allButtonsPassed = true;
            nonPowerButtons.forEach(button => {
              const buttonResult = this.testResultMessages[button.name];
              if (buttonResult === this.$t('ProductDiagnosis.notPassed') || !buttonResult) {
                allButtonsPassed = false;
              }
            });
            
            this.testResultMessages['D1'] = allButtonsPassed ? this.$t('ProductDiagnosis.passed') : this.$t('ProductDiagnosis.notPassed');
          }
      }
      
      // 对于所有测试步骤，保持原有的行为不变
      // 等待saveTestResults执行完成，确保所有测试结果都被正确处理和保存
      await this.saveTestResults();
      
      // 在saveTestResults完全执行完成后，再调用resetButtonTestsStatus
      this.resetButtonTestsStatus();
      
      // 设置本地状态为完成
      this.testCompleted = true;
      // 通知父组件测试已完成
      this.$emit('complete-test');
      this.testStarted = false;
      EventBus.emit('test-status-change', false); // 发送测试结束的状态
      this.isTesting = false;
    },
    async skipAndComplete() {
      // 获取当前步骤的itemid
      const currentItemId = this.testSteps[this.currentTestStep]?.command?.itemid;
      if (currentItemId) {
        if (currentItemId !== "D1") {
          // 直接将测试结果设置为未测试，避免依赖服务器响应或默认值，但跳过D1（按键测试）
          this.testResultMessages[currentItemId] = this.$t('ProductDiagnosis.untested');
        }
        
        // 发送取消测试指令
        const cancelCommand = {
          "cmd": "DeviceTestCancel",
          "param": currentItemId
        };
        this.sendCommand(cancelCommand);
      }
      // 调用completeTest完成测试
      await this.completeTest();
    },
    // 新增方法
    initializeTestItems() {
      let testItems = [
        {
          category: this.$t('ProductDiagnosis.motor'),
          checked: false,
          tests: [
            {label: this.$t('ProductDiagnosis.speedSensorTest'), value: 6, id: 'speedSensorTest', itemid: 'M2'},
            {label: this.$t('ProductDiagnosis.cadenceSensorTest'), value: 3, id: 'cadenceSensorTest', itemid: 'M3'},
            {label: this.$t('ProductDiagnosis.torqueSensorTest'), value: 4, id: 'torqueSensorTest', itemid: 'M6'},
            {label: this.$t('ProductDiagnosis.headlightTest'), value: 7, id: 'headlightTest', itemid: 'M1'},
            {label: this.$t('ProductDiagnosis.brakeSensorTest'), value: 2, id: 'brakeSensorTest', itemid: 'M5'},
            {label: this.$t('ProductDiagnosis.gearSensorTest'), value: 1, id: 'gearSensorTest', itemid: 'M4'},
            {label: this.$t('ProductDiagnosis.throttleSignalTest'), value: 5, id: 'throttleSignalTest', itemid: 'M7'},
            {label: this.$t('ProductDiagnosis.motorDriveTest'), value: 8, id: 'motorDriveTest', itemid: 'M9'},
          ],
          checkedTests: [],
        }
      ];

      if (this.isDisplayConnected) {
        const dashboardTests = [
          {label: this.$t('ProductDiagnosis.buttonTest'), value: 9, id: 'buttonTest', itemid: 'D1'},
        ];

        // 将所有仪表板测试项的值加入到checkedTests数组
        const checkedDashboardTests = dashboardTests.map(test => test.label);

        testItems.push({
          category: this.$t('ProductDiagnosis.display'),
          checked: true, // 假设仪表盘测试项默认选中
          tests: dashboardTests,
          checkedTests: checkedDashboardTests, // 使所有仪表板测试项默认选中
        });
        this.checkedList.push(...checkedDashboardTests);
      }

      // 电机部分的选项根据motorConfigData?.externaldevices更新
      if (this.motorConfigData && this.motorConfigData.externaldevices) {
        // 注意：这里假设externaldevices数组中存储的是字符串形式的数字
        this.checkedList = this.motorConfigData.externaldevices.map(Number) // 将字符串转换为数字
            .map(value => {
              const testItem = testItems[0].tests.find(test => test.value === value);
              return testItem ? testItem.label : null;
            })
            .filter(label => label !== null);
      }

      // 动态添加电机温度检测项，如果有温度传感器
      if (this.motorConfigData && this.motorConfigData.MotorTemperatureProtectionEnable === '1') {
        const motorTempTest = {
          label: this.$t('ProductDiagnosis.motorTempTest'),
          value: 9,
          id: 'motorTempTest',
          itemid: 'M8'
        };
        testItems[0].tests.push(motorTempTest);
      }
      this.testItems = testItems;
    },
    setTestResult(result) {
      if (result === 3) {
        this.lightResult = 3;
      } else {
        this.lightResult = result;
      }
      // 假设有一个方法或变量可以设置当前测试步骤的结果
      //this.lightResult = result;
    },
    skipHeadlightTest() {
      // 跳过大灯测试,不要求选择结果
      this.lightResult = null;
      
      // 获取下一个测试步骤
      const nextStepName = this.testSteps[this.currentTestStep + 1]?.name;
      
      // 发送关闭大灯命令
      this.sendCommand({cmd: "closeLight", param: ""});
      
      // 延迟后继续下一步
      setTimeout(() => {
        this.continueToNextTestStep(nextStepName);
      }, 500);
    },
    handleCloseLightResponse(message) {
      // 处理开灯指令的响应
      console.debug(this.$t('ProductDiagnosis.closeLightResponse'), message);
    },
    handleOpenLightResponse(message) {
      // 处理开灯指令的响应
      console.debug(this.$t('ProductDiagnosis.openLightResponse'), message);
    },
    handleTestCancelResponse(message) {
      if (message.code === 200) {
        console.debug(this.$t('ProductDiagnosis.testCancelSuccess'));
      }
    },
    safeJSONParse(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        console.error('Error parsing JSON:', e);
        return null; // 或者根据需要返回一个默认值
      }
    },

    handleGenericTestResponse(message) {
      const data = this.safeJSONParse(message.data);
      this.testResultReceived = true; // 将标志设置为true，表示已收到结果
      
      // 如果测试结果已经是未测试，不处理服务器响应
      if (this.testResultMessages[data.itemid] === this.$t('ProductDiagnosis.untested')) {
        return;
      }
      
      // 检查result是否为true（考虑字符串和布尔值两种情况）
      const isResultTrue = data.result === true || data.result === 'true';
      
      // 如果result为true，则处理data.data
      if (isResultTrue) {
        // 将测试结果更新为"通过"，同时存储data.data的值
        this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.passed');
        // 例如，将data.data存储为新的键值对，键名可以根据需要定义，如`${data.itemid}-data`
        this.testResultMessages[`${data.itemid}_data`] = data.data;
      } else {
        // 如果result不为true，检查是否是取消测试
        if (data.data === 'Test canceled') {
          // 如果是取消测试，设置为未测试
          this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.untested');
        } else {
          // 如果不是取消测试，更新测试结果为"不通过"
          this.testResultMessages[data.itemid] = this.$t('ProductDiagnosis.notPassed');
        }

        if (data.itemid === "M9") {
          this.testResultMessages[`${data.itemid}_data`] = data.data;
        } else {
          this.testResultMessages[`${data.itemid}_data`] = '';
        }
      }

// 特定处理M9的逻辑
      if (data.itemid === "M9") {
        const stopTestCommand = {cmd: "stopMotorTest", param: ""};
        this.sendCommand(stopTestCommand);
      }
    },

    shouldShowTestStep(testId) {
      // 检查当前的测试步骤数组中是否有匹配的ID，并与当前的测试步骤索引相对应
      return this.activeStep === 2 && this.testSteps[this.currentTestStep]?.id === testId;
    },

    // 初始化勾选的测试项的结果
    initializeTestResultsForSelectedItems() {
      let initialResults = {}; // 使用一个临时对象存储结果

      this.testItems.forEach(category => {
        category.tests.forEach(test => {
          // Only initialize results for selected tests
          if (category.checked && Array.isArray(category.checkedTests) && category.checkedTests.includes(test.label)) {
            // Check if test.itemid exists to avoid errors
            if (test.itemid) {
              // 初始化按键测试为未测试状态
              if (test.itemid === 'D1') {
                initialResults[test.itemid] = this.$t('ProductDiagnosis.untested');
              } else {
                initialResults[test.itemid] = ''; // Initialize result to empty string in the temporary object
              }
            } else {
              console.warn('Test item missing itemid:', test);
            }
          }
        });
      });
      // Assign the new object to testResultMessages to ensure reactivity
      this.testResultMessages = initialResults; // <--- Ensure reactive update
    },

    // 添加一个方法来等待显示信息被处理
    waitForDisplayInfo() {
      return new Promise((resolve) => {
        const intervalId = setInterval(() => {
          if (this.isDisplayInfoReceived) {
            clearInterval(intervalId);
            resolve();
          }
        }, 100); // 每100毫秒检查一次
      });
    },

    async nextStep() {
      if (this.activeStep === 1) {
        this.generateTestSteps();

        // 检查是否至少选择了一个类别项
        const anyCategorySelected = this.testItems.some(item => item.checked);

        if (!anyCategorySelected) {
          // 如果没有选择任何类别项，则提示用户
          this.$message({
            message: this.$t('ProductDiagnosis.selectCategoryWarning'),
            type: 'warning',
            duration: 3000, // 持续时间3秒
            offset: 300
          });
          return;
        }

        // 检查是否至少选择了一个测试项
        const anyTestSelected = this.testItems.some(item => item.checkedTests.length > 0);
        if (!anyTestSelected) {
          // 如果没有选择任何测试项，则提示用户
          this.$message({
            message: this.$t('ProductDiagnosis.selectTestWarning'),
            type: 'warning',
            duration: 3000, // 持续时间3秒
            offset: 300
          });

          return;
        }

        // 初始化选中测试项的结果
        this.initializeTestResultsForSelectedItems();

        // 检查是否有仪表盘测试项被勾选
        const dashboardTestChecked = this.testItems.some(item =>
            item.category === this.$t('ProductDiagnosis.display') && item.checkedTests.length > 0
        );

        // 如果有仪表盘检测项被勾选，发送获取显示信息配置的命令
        if (dashboardTestChecked) {
          this.sendCommand({"cmd": "getDisplayInfo_Config", "param": ""});
          //await this.getDisplayInfoConfigPromise(); // 等待获取显示信息配置的响应
          // 等待显示信息被处理
          await this.waitForDisplayInfo();
        }

        await this.updateStepCommands();

        if (this.testSteps && this.testSteps.length > 0) {
          // 有测试步骤时，准备执行第一个测试步骤
          this.currentTestStep = 0;
          this.activeStep += 1;
          EventBus.emit('test-status-change', true); // 发送测试正在进行的状态
          this.isTesting = true;  // 在有确认的测试步骤后设置

          // 发送第一个测试步骤的命令
          const currentTest = this.testSteps[this.currentTestStep];
          const command = this.stepCommands[currentTest.name];

          if (!currentTest || !command || !command.itemid) {
          // 测试步骤初始化错误
          return;
        }

          // 假设每个测试步骤的ID或名称都已经定义好
          const currentTestId = this.testSteps[this.currentTestStep]?.id;

          // 按键测试特殊处理
          if (currentTestId === 'buttonTest') {
            // 按键测试不发送命令，直接跳过下面的发送逻辑
            if (this.displayedButtons && this.displayedButtons.length > 0) {
              this.handleButtonClick(0); // 开始第一个按键的测试
              this.displayedButtons[0].status = 'detecting'; // 设置第一个按键的状态为"检测中"
            } else {
              // 如果没有显示的按钮，直接跳过按键测试
              this.continueToNextTestStep(this.testSteps[this.currentTestStep + 1]?.name);
            }
            // 注意：不再需要调用startCountdown，因为handleButtonClick方法会自动启动倒计时
            return;
          }

          // 根据测试步骤ID调整倒计时时间
          if (currentTestId === 'buttonTest') {
            this.totalTime = this.remainingTime = 25; // 按键检测为25秒
          } else {
            this.totalTime = this.remainingTime = 30; // 其他测试为默认的30秒
          }
          // 启动倒计时，传递当前测试步骤的ID
          this.startCountdown(currentTestId);

          if (currentTest.name === this.$t('ProductDiagnosis.motorDriveTest')) {
            this.showBatteryCheckModal = true; // 显示电池检查模态框
            clearInterval(this.countdownInterval); // 停止倒计时
            // 这里可能需要return或者其他逻辑来阻止发送命令
          } else {
            // 发送第一个测试步骤的命令
            if (command) {
              this.sendCommand(command);
            }
          }

        } else {
          // 没有测试步骤时直接进入下一步
          this.activeStep += 1;
        }
      }
      // 判断是否为最后一步
      this.isLastStep = this.activeStep - 1 === this.testSteps.length;
    },

    proceedToNextTestStep() {
      if (this.currentTestStep >= this.testSteps.length) {
        console.error('currentTestStep index out of bounds');
        return;
      }
      // 直接从当前测试步骤获取 itemid
      const currentItemId = this.testSteps[this.currentTestStep]?.id;
      const currentTestCommand = this.testSteps[this.currentTestStep]?.command;

      if (!currentTestCommand) {
        console.error('command is undefined for the current test step');
        return;
      }

      const currentTestItemId = this.testSteps[this.currentTestStep]?.command.itemid;

      if (currentItemId === "motorDriveTest") {
        const stopTestCommand = {cmd: "stopMotorTest", param: ""};
        this.sendCommand(stopTestCommand);
      }

      // D1指令点击下一步后发送取消指令
      if (currentTestItemId === "D1") {
        // 保存当前的D1测试结果
        const currentD1Result = this.testResultMessages['D1'];
        
        this.sendCommand({
          cmd: "DeviceTestCancel",
          param: "D1"
        });
        // 清除所有按键测试的setTimeout
        if (this.buttonTestTimeouts && this.buttonTestTimeouts.length > 0) {
          this.buttonTestTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
          this.buttonTestTimeouts = [];
        }
        // 清除倒计时定时器
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
        // 重置按键测试状态，确保再次开始测试时按键状态正确
        this.resetButtonTestsStatus();
        // 只有当没有实际测试结果时，才将结果设置为"未测试"
        if (currentD1Result && currentD1Result !== "") {
          // 如果已经有实际测试结果，则保持实际的测试结果
          this.testResultMessages['D1'] = currentD1Result;
        } else {
          // 如果没有实际测试结果，则设置为"未测试"
          this.testResultMessages['D1'] = this.$t('ProductDiagnosis.untested');
        }
      }

      const currentStepName = this.testSteps[this.currentTestStep]?.name;
// 获取下一个测试步骤的名称，用于后续逻辑判断
      const nextStepName = this.testSteps[this.currentTestStep + 1]?.name;

      // 检查是否为大灯检测，并且是否选择了结果
      if (currentStepName === this.$t('ProductDiagnosis.headlightTest') && !this.lightResult) {
        this.$message({
          message: this.$t('ProductDiagnosis.selectHeadlightResult'),
          type: 'warning',
          duration: 3000, // 持续时间3秒
          offset: 300
        });
        return; // 退出函数，不进行下一步
      }

      // 检查当前步骤是否完成，这里的逻辑可能需要根据你的应用逻辑调整
      const isCurrentStepComplete = this.checkIfCurrentStepComplete(currentStepName);

      if (!isCurrentStepComplete) {
        if (currentStepName !== this.$t('ProductDiagnosis.headlightTest')) {
          // 如果当前步骤未完成，发送取消测试命令
          if (currentTestItemId) {
              // D1的取消命令已经在上面单独处理了
              if (currentTestItemId !== "D1") {
                const cancelCommand = {"cmd": "DeviceTestCancel", "param": currentTestItemId ? currentTestItemId : ""};
                this.sendCommand(cancelCommand);
                // 对于APP通讯检测(D2)，取消测试应视为未通过，而不是未测试
                if (currentTestItemId === 'D2') {
                  this.testResultMessages[currentTestItemId] = this.$t('ProductDiagnosis.notPassed');
                } else {
                  // 其他测试项，直接将测试结果设置为未测试，避免依赖服务器响应
                  this.testResultMessages[currentTestItemId] = this.$t('ProductDiagnosis.untested');
                }
              } else {
                // 对于D1（按键测试），不设置结果为未测试，保持实际测试结果
                // 按键测试的结果已经在其他地方计算和设置了
              }
            }
          this.$message({
            message: this.$t('ProductDiagnosis.skippingTestItem'),
            type: 'warning',
            duration: 3000, // 持续时间3秒
            offset: 300 // 调整垂直偏移量，单位为像素
          });
        }

      }

      if (currentStepName === this.$t('ProductDiagnosis.headlightTest')) {
        this.sendCommand({cmd: "closeLight", param: ""});

        // 无论是否收到关闭大灯的响应，都在一定时间后继续执行下一步
        setTimeout(() => {
          this.continueToNextTestStep(nextStepName);
        }, 500); // 3秒后执行，此时间可以根据实际情况调整

      } else {
        this.continueToNextTestStep(nextStepName);
      }

      // 无论是否进入下一个步骤，都在这里判断是否为最后一个步骤并更新 isLastStep
      this.isLastStep = this.currentTestStep >= this.testSteps.length - 1; // <--- 确保在这里更新
    },

    // 新增一个方法来处理继续下一步的逻辑
    continueToNextTestStep(nextStepName) {
      // 此处currentIndex参数未使用，而是直接操作this.currentTestStep
      if (this.currentTestStep < this.testSteps.length - 1) {

        // 移动到下一个测试步骤
        this.currentTestStep += 1;

        if (this.currentTestStep === this.testSteps.length - 1) {
          this.isLastStep = true;
        }

        if (nextStepName === this.$t('ProductDiagnosis.motorDriveTest')) {
          // 如果是电机驱动测试，显示电池检查模态框
          this.showBatteryCheckModal = true;
          this.startCountdown(); // 启动倒计时
          clearInterval(this.countdownInterval); // 停止倒计时
        } else if (nextStepName === this.$t('ProductDiagnosis.buttonTest')) {
          // 按键测试特殊处理，不在这里发送指令，因为handleButtonClick会发送
          // 注意：不再需要调用startCountdown，因为handleButtonClick方法会自动启动倒计时
          // 如果有显示的按钮，开始第一个按键的测试
          if (this.displayedButtons && this.displayedButtons.length > 0) {
            this.handleButtonClick(0); // 开始第一个按键的测试
            this.displayedButtons[0].status = 'detecting'; // 设置第一个按键的状态为"检测中"
          } else {
            // 如果没有显示的按钮，直接跳过按键测试
            this.continueToNextTestStep(this.testSteps[this.currentTestStep + 1]?.name);
          }
        } else {
          // 非特殊测试步骤，启动倒计时并发送指令
          // 获取当前测试步骤的ID用于startCountdown
          const currentTestId = this.testSteps[this.currentTestStep]?.id;
          this.startCountdown(currentTestId);
          
          const command = this.stepCommands[nextStepName];
          if (command) {
            this.sendCommand(command);
          }
        }
      } else {
        // 已经是最后一个测试步骤，适当处理，比如显示完成按钮等
        this.isLastStep = true; // 设置为最后一步
        // 完成所有测试步骤，递增activeStep以退出测试

        this.activeStep += 1;
      }
    },

    sendCommand(command) {
      try {
        this.getWs.send(JSON.stringify(command));
      } catch (error) {
        console.error(this.$t('ProductDiagnosis.commandSendError'), error);
      }
    },

    generateTestSteps() {

      this.testSteps = []; // 清空当前的测试步骤数组
      
      // 遍历所有测试项，按照分类顺序和每个分类内部的原始顺序添加到testSteps
      this.testItems.forEach(categoryItem => {
        // 确保电机测试分类在仪表测试分类之前处理
        if (categoryItem.category === this.$t('ProductDiagnosis.motor')) {
          // 处理电机测试，保持内部原始顺序
          categoryItem.tests.forEach(test => {
            if (Array.isArray(categoryItem.checkedTests) && categoryItem.checkedTests.includes(test.label)) {
              this.testSteps.push({
                id: test.id,
                name: test.label,
                command: this.stepCommands[test.label]
              });
            }
          });
        }
      });
      
      // 处理非电机测试分类（如仪表测试），保持内部原始顺序
      this.testItems.forEach(categoryItem => {
        if (categoryItem.category !== this.$t('ProductDiagnosis.motor')) {
          categoryItem.tests.forEach(test => {
            if (Array.isArray(categoryItem.checkedTests) && categoryItem.checkedTests.includes(test.label)) {
              this.testSteps.push({
                id: test.id,
                name: test.label,
                command: this.stepCommands[test.label]
              });
            }
          });
        }
      });
    },

    getItemIdFromStepName(stepName) {
      // 这里假设每个命令对象都有一个itemid字段
      return this.stepCommands[stepName]?.itemid || null;
    },

    // 根据你的应用逻辑实现这个方法，判断当前步骤是否完成
    checkIfCurrentStepComplete(stepName) {
      // 从步骤名称获取itemid
      const itemid = this.getItemIdFromStepName(stepName);
      // 检查testResultMessages对象中对应itemid的结果是否存在且不是空字符串
      return (this.testResultMessages[itemid] !== undefined && this.testResultMessages[itemid] !== '') || this.remainingTime <= 0;
    },

    firstNextStep() {
      if (this.activeStep === 0) {
        // 当从第一步转到第二步时，根据选择的外设更新测试项
        this.filterTestItemsBasedOnSelection();
      }

      if (this.activeStep < this.totalTestStep) {
        this.activeStep++;
      }
    },

    filterTestItemsBasedOnSelection() {
      const valueToLabelMap = this.getValueToLabelMap();
      this.testItems.forEach(categoryItem => {
        if (!Array.isArray(this.checkedList) || !Array.isArray(this.alwaysShownTests)) {
          console.error('checkedList or alwaysShownTests is not an array', this.checkedList);
          return;
        }

        let newCheckedTests = categoryItem.tests.filter(test =>
            (typeof valueToLabelMap[test.value] === 'string' && this.checkedList.includes(valueToLabelMap[test.value])) ||
            this.alwaysShownTests.includes(test.value)
        ).map(test => test.label);

        if (categoryItem.category === this.$t('ProductDiagnosis.motor') && this.motorConfigData && this.motorConfigData.MotorTemperatureProtectionEnable === '1') {
          const motorTempTestValue = categoryItem.tests.find(test => test.id === 'motorTempTest')?.label;
          if (motorTempTestValue && !newCheckedTests.includes(motorTempTestValue)) {
            newCheckedTests.push(motorTempTestValue);
          }
        }

        // 如果当前类别默认选中（电机和仪表），则保留默认选中状态
        if (categoryItem.category === this.$t('ProductDiagnosis.motor') && this.isMotorConnected) {
          //categoryItem.checkedTests = categoryItem.tests.map(test => test.label);
          categoryItem.checkedTests = newCheckedTests;
          categoryItem.checked = true;
        } else if (categoryItem.category === this.$t('ProductDiagnosis.display') && this.isDisplayConnected) {
          categoryItem.checkedTests = categoryItem.tests.map(test => test.label);
          categoryItem.checked = true;
        } else {
          categoryItem.checkedTests = newCheckedTests;
          categoryItem.checked = newCheckedTests.length > 0;
        }
      });

      // 更新测试步骤
      // this.generateTestSteps();
    },
    getFilteredTests(row) {
      const valueToLabelMap = this.getValueToLabelMap();
      let filteredTests = [];

      if (!Array.isArray(this.checkedList) || !Array.isArray(this.alwaysShownTests)) {
        console.error('checkedList or alwaysShownTests is not an array');
        return []; // 提早返回空数组以避免错误
      }

      if (row.category === this.$t('ProductDiagnosis.motor')) {
        filteredTests = row.tests.filter(test => {
          const isInCheckedList = this.checkedList.includes(valueToLabelMap[test.value]);
          const isInAlwaysShownTests = this.alwaysShownTests.includes(test.value);
          return isInCheckedList || isInAlwaysShownTests;
        });

        if (this.motorConfigData && this.motorConfigData.MotorTemperatureProtectionEnable === '1') {
          const motorTempTestExists = filteredTests.some(test => test.id === 'motorTempTest');
          if (!motorTempTestExists) {
            const motorTempTest = row.tests.find(test => test.id === 'motorTempTest');
            if (motorTempTest) {
              filteredTests.push(motorTempTest);
            }
          }
        }

      } else if (row.category === this.$t('ProductDiagnosis.display')) {
        filteredTests = row.tests;
      }

      return filteredTests;
    },

    previousStep() {
      if (this.activeStep > 0) {
        this.activeStep--;
      }
    },
    shouldDisplayRow(row) {
      if (row.category === this.$t('ProductDiagnosis.motor')) {
        return this.isMotorConnected;
      } else if (row.category === this.$t('ProductDiagnosis.display')) {
        return this.isDisplayConnected;
      }
      return true;
    },
    formatTime() {
      // 因为剩余时间与百分比成正比，我们可以直接返回剩余时间
      return `${this.remainingTime}s ${this.$t('ProductDiagnosis.remainingTime')}`;
    },

    startCountdown(testId = null) {
      // 优先使用传入的testId，如果没有则从当前测试步骤获取
      const currentTestStep = this.testSteps[this.currentTestStep];
      const currentTestId = testId || (currentTestStep ? currentTestStep.id : null);
      
      // 根据测试步骤ID调整倒计时时间
      if (currentTestId === 'buttonTest') {
        this.totalTime = this.remainingTime = 20; // 按键检测为20秒，与startTest方法保持一致
      } else {
        this.totalTime = this.remainingTime = 30; // 其他测试为默认的30秒
      }

      // 如果已存在倒计时，先清除现有的倒计时。这确保不会有多个倒计时同时运行。
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // 设置一个新的倒计时。这里使用 setInterval 每秒钟减少剩余时间，并执行相关逻辑。
      this.countdownInterval = setInterval(() => {

        if (this.remainingTime > 0) {
          // 如果还有剩余时间，减少1秒。
          this.remainingTime -= 1;
        } else {
          // 如果时间用完，执行以下逻辑。
          clearInterval(this.countdownInterval); // 停止倒计时
          
          // 只有在不是按键测试的情况下才发送取消指令
          if (currentTestId !== 'buttonTest') {
            const currentTestStep = this.testSteps[this.currentTestStep];
            if (currentTestStep) {
              const currentTestItemId = currentTestStep.command?.itemid;
              if (currentTestItemId) {
                const cancelCommand = {"cmd": "DeviceTestCancel", "param": currentTestItemId};
                this.sendCommand(cancelCommand);
              }
            }
          }
          
          if (this.isInButtonTest) {
            // 按键测试阶段，检查是否完成了所有按钮测试
            if (this.currentButtonIndex >= this.displayedButtons.length - 1) {
              // 如果已经是最后一个按钮且测试完成，且不是测试的最后一步，自动进入下一步
              if (!this.isLastStep) {
                this.proceedToNextTestStep();
              }
            } else {
              // 如果不是最后一个按钮，继续等待设备响应，直到收到完整的按下和松开阶段响应
              // 测试结果将由handleDashboardTestD1方法根据设备实际响应结果来判断
            }
          } else if (currentTestId === 'buttonTest') {
            // 如果是按键测试阶段，检查是否完成了所有按钮测试
            if (this.currentButtonIndex >= this.displayedButtons.length - 1) {
              // 如果已经是最后一个按钮且测试完成，且不是测试的最后一步，自动进入下一步
              if (!this.isLastStep) {
                this.proceedToNextTestStep();
              }
            } else {
              // 如果不是最后一个按钮，允许用户点击下一个按钮开始测试
              // 不自动进入下一步，等待用户操作
            }
          } else {
            if (!this.isLastStep) {
              // 如果还没有到达测试流程的最后一步，继续下一步
              this.proceedToNextTestStep();
            }
          }
        }
      }, 1000); // setInterval 的时间间隔设置为1000毫秒，即每秒执行一次。
    },

    onCategoryCheckedChange(row) {
      if (row.checked) {
        row.checkedTests = row.tests.map(test => test.label);
      } else {
        row.checkedTests = [];
      }

      if (row.category === this.$t('ProductDiagnosis.display')) {
        this.updateDisplayTestsSelection(row.checked); // 更新仪表盘测试项的选中状态
      }
    },
    toggleCategory(row) {
      const allSelected = row.checkedTests.length === row.tests.length;
      if (allSelected) {
        row.checked = false;
        row.checkedTests = [];
      } else {
        row.checked = true;
        row.checkedTests = row.tests.map(test => test.label);
      }
      this.onCategoryCheckedChange(row); // 调用 onCategoryCheckedChange 来处理选中状态变化

    },
    updateDisplayTestsSelection(isChecked) {
      // 查找仪表盘的测试项
      const displayTestItem = this.testItems.find(item => item.category === this.$t('ProductDiagnosis.display'));
      if (displayTestItem) {
        if (isChecked) {
          // 将所有仪表盘测试项标记为选中
          displayTestItem.checkedTests = displayTestItem.tests.map(test => test.label);
        } else {
          // 清空所有仪表盘测试项的选中状态
          displayTestItem.checkedTests = [];
        }
      }
    },

    deviceName(deviceCode) {
      const deviceName = {
        '1': this.$t('ProductDiagnosis.brakeSensor'),
        '2': this.$t('ProductDiagnosis.wheelSensor'),
        '3': this.$t('ProductDiagnosis.pedalSensor'),
        '4': this.$t('ProductDiagnosis.handlebarSensor'),
        '5': this.$t('ProductDiagnosis.torqueSensor'),
      };
      return deviceName[deviceCode] || this.$t('ProductDiagnosis.unknownDevice');
    },

    async startTest() {
      // UI关键操作：立即切换到测试页面
      this.activeStep = 2; // 直接设置为2，跳过前面的步骤
      this.testCompleted = false;
      this.testStarted = true;
      this.currentTestStep = 0;
      
      // 确保UI立即渲染
      await this.$nextTick();
      
      // 执行初始化操作
      await this.performBackgroundInitialization();
      
      // 在初始化完成后，根据实际生成的测试步骤启动倒计时
      if (this.testSteps && this.testSteps.length > 0) {
        const currentTest = this.testSteps[this.currentTestStep];
        const currentTestId = currentTest?.id;
        
        // 根据实际测试步骤设置倒计时时间
        if (currentTestId === 'buttonTest') {
          this.totalTime = this.remainingTime = 25;
        } else {
          this.totalTime = this.remainingTime = 30;
        }
        
        // 启动倒计时
        this.startCountdown(currentTestId);
      }
      
    },
    
    // 后台执行非UI关键的初始化操作
    async performBackgroundInitialization() {
      
      // 重置测试状态 - 保持选项一致
      this.testResultMessages = {};
      this.lightResult = null;
      this.isLastStep = false;

      // 调用初始化测试项的方法，基于电机和仪表的连接状态
      this.initializeTestItemsBasedOnConnection();

      if (this.motorConfigData && this.motorConfigData.externaldevices) {
        // 使用 deviceName 函数将设备代码转换为设备名称
        this.checkedList = this.motorConfigData.externaldevices.map(code => this.deviceName(code)).filter(name => name !== this.$t('ProductDiagnosis.unknownDevice'));
      } else {
        this.checkedList = [];
      }

      // 重置按键测试的状态
      this.resetButtonTestsStatus();

      this.$emit('start-test');
      EventBus.emit('test-started', true);

      // 非阻塞方式记录操作，不影响测试流程
      recordOperation({action: 'dynamic-test'}).catch(() => {
        // 操作记录失败处理
      });

      // 模拟执行第一步的逻辑 (filterTestItemsBasedOnSelection)
      this.filterTestItemsBasedOnSelection();

      // 检查是否有仪表盘测试项被勾选，如果勾选则获取显示信息配置
      const dashboardTestChecked = this.testItems.some(item =>
          item.category === this.$t('ProductDiagnosis.display') && item.checkedTests.length > 0
      );


      if (dashboardTestChecked) {
        // 重置显示信息接收状态，确保waitForDisplayInfo能正确等待新的响应
        this.isDisplayInfoReceived = false;
        this.sendCommand({"cmd": "getDisplayInfo_Config", "param": ""});
        // 异步等待显示信息被处理，不阻塞测试流程
        this.waitForDisplayInfo();
      }

      // 模拟执行第二步的逻辑 (generateTestSteps)
      this.generateTestSteps();

      // 异步获取最新的阈值信息，更新 stepCommands，不阻塞测试流程
      this.updateStepCommands();

      // 初始化测试结果
      this.initializeTestResultsForSelectedItems();

      // 如果有测试步骤，开始执行第一个测试步骤
      if (this.testSteps && this.testSteps.length > 0) {
        this.currentTestStep = 0;

        EventBus.emit('test-status-change', true);
        this.isTesting = true;

        // 发送第一个测试步骤的命令
        const currentTest = this.testSteps[this.currentTestStep];
        const command = this.stepCommands[currentTest.name];

        if (!currentTest || !command || !command.itemid) {
          console.error('Current test step or command is not properly initialized', currentTest);
          return;
        }

        const currentTestId = this.testSteps[this.currentTestStep]?.id;

        // 重新启动倒计时，使用当前测试步骤的ID，覆盖startTest中设置的错误参数
        this.startCountdown(currentTestId);
        
        // UI更新由Vue的响应式系统自动处理，无需强制更新

        // 开始处理按键测试
        if (currentTestId === 'buttonTest') {
          // 按键测试不发送命令，直接跳过下面的发送逻辑
          if (this.displayedButtons && this.displayedButtons.length > 0) {
            this.handleButtonClick(0); // 开始第一个按键的测试
            this.displayedButtons[0].status = 'detecting'; // 设置第一个按键的状态为"检测中"
          } else {
            // 如果没有显示的按钮，等待一段时间后重试，避免立即跳过按键测试
            const retryButtonTest = () => {
              if (this.displayedButtons && this.displayedButtons.length > 0) {
                this.handleButtonClick(0); // 开始第一个按键的测试
                this.displayedButtons[0].status = 'detecting'; // 设置第一个按键的状态为"检测中"
              } else {
                // 如果重试后还是没有按钮，再跳过按键测试
                this.continueToNextTestStep(this.testSteps[this.currentTestStep + 1]?.name);
              }
            };
            // 延迟一段时间后重试，给足够时间获取显示信息
            setTimeout(retryButtonTest, 1000);
          }
        }
        if (currentTest.name === this.$t('ProductDiagnosis.motorDriveTest')) {
          this.showBatteryCheckModal = true;
          clearInterval(this.countdownInterval);
        } else if (currentTestId !== 'buttonTest') {
          if (command) {
            this.sendCommand(command);
          }
        }
        // 在这里判断并设置 isLastStep 的初始值是否为 true
        // 如果 testSteps 只有一步，那么第一个步骤就是最后一个步骤
        if (this.testSteps.length === 1) {
          this.isLastStep = true;
        } else {
          this.isLastStep = false;
        }

      } else {
        // 如果没有生成测试步骤（例如，没有连接任何设备或没有勾选任何测试项），
        // 则可以停留在连接设备界面（activeStep = 0）或显示一个提示信息。
        // 这里我们让它停留在 activeStep = 0 的状态，并可能显示"无设备连接"或类似信息
        EventBus.emit('test-status-change', false); // 发送测试结束的状态
        this.isTesting = false;
        // 使用更准确的国际化词
        this.$message({
          message: this.$t('ProductDiagnosis.noTestItemsSelected'),
          type: 'warning',
          duration: 3000,
          offset: 300
        });
      }
    },
    initializeTestItemsBasedOnConnection() {
      // 创建一个映射表，将 availableDevices 中的名称映射到 tests 的标签
      const deviceLabelMap = {
        [this.$t('ProductDiagnosis.torqueSensor')]: 'torqueSensorTest',
        [this.$t('ProductDiagnosis.cadenceSensor')]: 'cadenceSensorTest',
        [this.$t('ProductDiagnosis.brakeSensor')]: 'brakeSensorTest',
        [this.$t('ProductDiagnosis.gearSensor')]: 'gearSensorTest',
        [this.$t('ProductDiagnosis.throttle')]: 'throttleSignalTest',
      };

      // 将 availableDevices 转换为对应 tests 标签的名称
      const mappedAvailableDevices = this.availableDevices.map(device => deviceLabelMap[device] || device);

      let newTestItems = [];

      // 电机测试项
      if (this.isMotorConnected) {
        newTestItems.push({
          category: this.$t('ProductDiagnosis.motor'),
          checked: true, // 默认勾选电机类别
          tests: [
            {label: this.$t('ProductDiagnosis.speedSensorTest'), value: 6, id: 'speedSensorTest', itemid: 'M2'},
            {label: this.$t('ProductDiagnosis.cadenceSensorTest'), value: 3, id: 'cadenceSensorTest', itemid: 'M3'},
            {label: this.$t('ProductDiagnosis.torqueSensorTest'), value: 4, id: 'torqueSensorTest', itemid: 'M6'},
            {label: this.$t('ProductDiagnosis.headlightTest'), value: 7, id: 'headlightTest', itemid: 'M1'},
            {label: this.$t('ProductDiagnosis.brakeSensorTest'), value: 2, id: 'brakeSensorTest', itemid: 'M5'},
            {label: this.$t('ProductDiagnosis.gearSensorTest'), value: 1, id: 'gearSensorTest', itemid: 'M4'},
            {label: this.$t('ProductDiagnosis.throttleSignalTest'), value: 5, id: 'throttleSignalTest', itemid: 'M7'},
            {label: this.$t('ProductDiagnosis.motorDriveTest'), value: 8, id: 'motorDriveTest', itemid: 'M9'}
          ].filter(test => {
            // 如果mappedAvailableDevices为空，不过滤任何测试项（解决无痕模式下第一次打开页面的问题）
            // 否则，根据availableDevices过滤测试项
            return mappedAvailableDevices.length === 0 || 
                ['speedSensorTest', 'headlightTest', 'motorDriveTest'].includes(test.id) ||
                mappedAvailableDevices.some(device => test.id.includes(device));
          }).map(test => ({
            ...test,
            checked: true // 默认勾选所有电机测试项
          }))
        });
      }

      // 仪表测试项
      if (this.isDisplayConnected) {
        const dashboardTests = [
          {label: this.$t('ProductDiagnosis.buttonTest'), value: 9, id: 'buttonTest', itemid: 'D1'}
        ].map(test => ({
          ...test,
          checked: true // 默认勾选所有仪表盘测试项
        }));

        // 创建仪表测试类别
        const displayCategory = {
          category: this.$t('ProductDiagnosis.display'),
          checked: true, // 默认勾选仪表盘类别
          tests: dashboardTests,
          checkedTests: dashboardTests.map(test => test.label) // 使所有仪表板测试项默认选中
        };

        newTestItems.push(displayCategory);

        // 更新 checkedList，添加仪表测试项
        this.checkedList = [...this.checkedList, ...dashboardTests.map(test => test.label)];
      }

      // 电机部分的选项根据motorConfigData?.externaldevices更新
      if (this.motorConfigData && this.motorConfigData.externaldevices) {
        this.checkedList = this.motorConfigData.externaldevices.map(Number)
            .map(value => {
              const testItem = newTestItems[0]?.tests.find(test => test.value === value);
              return testItem ? testItem.label : null;
            })
            .filter(label => label !== null);
      }

      // 动态添加电机温度检测项，如果有温度传感器
      if (this.motorConfigData && this.motorConfigData.MotorTemperatureProtectionEnable === '1') {
        const motorTempTest = {
          label: this.$t('ProductDiagnosis.motorTempTest'),
          value: 9,
          id: 'motorTempTest',
          itemid: 'M8'
        };
        if (newTestItems[0]) {
          newTestItems[0].tests.push(motorTempTest);
        }
      }

      this.testItems = newTestItems; // 更新测试项目数组
    },

    updateCheckedList() {
      // 收集所有被勾选的测试项标签
      this.checkedList = this.testItems
          .flatMap(category =>
              category.checked ? category.tests.map(test => test.label) : []
          );
    },

    resetButtonTestsStatus() {
      // 清除所有按钮的测试结果
      if (this.displayedButtons) {
        this.displayedButtons.forEach(button => {
          delete this.testResultMessages[button.name];
          // 重置displayedButtons中按钮的状态为waiting
          button.status = 'waiting';
        });
      }
      // 清除按键测试的总体结果
      delete this.testResultMessages['D1'];
      // 重置所有按钮的状态为waiting
      if (this.buttonTests) {
        this.buttonTests.forEach(button => {
          button.status = 'waiting';
        });
      }
      // 重置当前按钮索引
      this.currentButtonIndex = 0;
      // 重置按键测试阶段
      this.buttonTestPhase = 'press';
      this.buttonPressStartTime = null;
      this.isInButtonTest = false;
      // 清除按键松开定时器
      if (this.buttonReleaseTimeout) {
        clearTimeout(this.buttonReleaseTimeout);
        this.buttonReleaseTimeout = null;
      }
      // 清除按键测试的setTimeout
      if (this.buttonTestTimeouts && this.buttonTestTimeouts.length > 0) {
        this.buttonTestTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
        this.buttonTestTimeouts = [];
      }
      // 清除倒计时定时器
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      // 重置剩余时间
      this.remainingTime = this.totalTime;
    },
    cancelCancelDialog() {
      this.showCancelDialog = false; // 隐藏对话框
    },
    //确认取消测试
    cancelTest() {
      this.showCancelDialog = false; // 关闭对话框
      // 直接从当前测试步骤获取 itemid
      const currentItemId = this.testSteps[this.currentTestStep]?.id;
      if (currentItemId === "motorDriveTest") {
        const stopTestCommand = {cmd: "stopMotorTest", param: ""};
        this.sendCommand(stopTestCommand);
      }
      // 如果需要发送关灯指令（例如在大灯测试步骤中），可以在这里加入条件检查
      if (this.testSteps[this.currentTestStep]?.id === 'headlightTest') {
        this.sendCommand({
          cmd: "closeLight",
          param: ""
        });
      }
      if (this.activeStep !== 0) {
        this.sendCommand({
          cmd: "DeviceTestCancel",
          param: this.testSteps[this.currentTestStep]?.command.itemid ? this.testSteps[this.currentTestStep]?.command.itemid : "",
        });
      }
      // 重置测试状态和UI
      this.resetTestState();
      // 测试取消
      this.$emit('cancel-test');
      EventBus.emit('test-started', false);
    },

    resetTestState() {
      this.testStarted = false;
      EventBus.emit('test-status-change', false); // 发送测试结束的状态
      this.isTesting = false; // 确保同时重置测试状态
      this.activeStep = 0;
      this.currentTestStep = 0;
      this.remainingTime = 30;
      this.totalTime = 30; // 重置总时间，确保进度条计算正确
      clearInterval(this.countdownInterval); // 停止倒计时
      
      // 重置按键测试状态
      this.resetButtonTestsStatus();
      
      // 清除按键松开定时器
      if (this.buttonReleaseTimeout) {
        clearTimeout(this.buttonReleaseTimeout);
        this.buttonReleaseTimeout = null;
      }

      // 重置所有用于UI显示和逻辑控制的变量
      this.testResultMessages = {};
      this.testSteps = [];
      // 重置 checkedList 基于当前的设备配置
      if (this.motorConfigData && this.motorConfigData.externaldevices) {
        this.checkedList = this.motorConfigData.externaldevices.map(code => this.deviceName(code)).filter(name => name !== this.$t('ProductDiagnosis.unknownDevice'));
      } else {
        // 如果没有外设或外设信息不可用，可以选择清空列表或设置为默认值
        this.checkedList = [];
      }
    },

    handleButtonClick(index) {
      // 如果测试已经取消或未开始，不处理按键点击事件
      if (!this.isTesting) {
        return;
      }
      
      const button = this.displayedButtons[index]; // 获取当前按钮对象

      if (!button) {
        console.error('Button not found at index:', index);
        return;
      }
      
      // 检查是否已经有按键测试正在进行中，如果是且不是当前点击的按钮，则不执行新的测试
      // 但是如果按钮已经测试过（状态为passed或failed），允许重新开始测试
      if (this.isInButtonTest && this.currentButtonIndex !== index) {
        // 检查点击的按钮是否已经测试过
        const clickedButton = this.displayedButtons[index];
        if (clickedButton.status === 'passed' || clickedButton.status === 'failed') {
          // 允许重新测试已经测试过的按钮
          // 先结束当前的按键测试
          this.isInButtonTest = false;
        } else {
          console.warn('A button test is already in progress, please wait for it to complete.');
          return;
        }
      }
      
      // 如果当前索引超出按钮数量范围，不发送指令
      if (index >= this.displayedButtons.length) {
        console.warn('Button index out of range:', index);
        return;
      }
      
      // 遍历所有按钮，根据不同的状态进行相应处理
      this.displayedButtons.forEach((btn, idx) => {
        if (btn.status === 'detecting' && idx !== index) {
          btn.status = 'failed'; // 将当前检测中的按钮状态设为不通过
        }
      });

      // 将当前点击的按钮状态设为检测中
      button.status = 'detecting';
      this.currentButtonIndex = index;

      // 如果p1值为1（电源键），则不发送指令
      if (button.p1 === '1') {
        // 设置 isInButtonTest 为 true，表示进入按键测试阶段
        this.isInButtonTest = true;
        return;
      }

      // 设置按键检测阶段为按下
      this.buttonTestPhase = 'press';
      this.buttonPressStartTime = null;

      // 每次按键测试都清除旧倒计时并启动新倒计时，确保每个按键有独立的倒计时
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      // 开始倒计时，传入'buttonTest'确保使用正确的25秒时间
      this.startCountdown('buttonTest');

      // 设置 isInButtonTest 为 true，表示进入按键测试阶段
      this.isInButtonTest = true;

      // 移除了5秒超时机制，确保只有收到设备响应后才进行下一步操作
      // 现在将根据设备的实际响应结果来决定测试流程

      // 确保DOM更新完成（提示文字显示）后再发送指令
      this.$nextTick(() => {
        // 发送按下指令（p2=1）
        const command = {
          "cmd": "DeviceTest",
          "itemid": "D1",
          "itemname": button.p1,
          "p1": button.p1,
          "p2": "1", // 第一阶段：按下
          "maxTestCount": "30"
        };
        this.sendCommand(command);
      });
    },


    // 参数可以根据你的实际情况进行调整
    shouldShowSpinner(testResult, remainingTime) {
      return testResult === '' && remainingTime > 0;
    },
    testResultClass(testResult) {
      return testResult === this.$t('ProductDiagnosis.passed') ? 'passed' : 'failed';
    },
    getWaitingText(buttonName) {
      if (this.buttonTestPhase === 'release') {
        return `请松开 ${buttonName} 键`;
      }
      return `请保持按住 ${buttonName} 键`;
    }

  }
}
</script>

<style scoped>
.placeholder-text {
  width: 300px; /* 与 img-size 中的 max-width 匹配 */
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #000;
  text-align: center;
}

.spinner-container {
  position: relative;
  width: 18px;
  height: 18px;
}

.dot1, .dot2 {
  width: 10px;
  height: 10px;
  background-color: rgb(0, 154, 68); /* 绿色 */
  border-radius: 50%;
  position: absolute;
  top: 10px;
  left: 50%;
  transform-origin: 0 50%;
  animation: spin 1s linear infinite;
}

.dot2 {
  animation-delay: -0.5s; /* 延迟半秒开始动画，使两点交替旋转 */
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.dialog-separator-other {
  border-top: 0.5px solid rgba(221, 221, 221, 0.1);
  width: 100%; /* 设置宽度为100%，确保与父容器内宽相匹配 */
}


.button-footer {
  margin-bottom: 10px;
}

.step-label {
  margin-left: 20px;
}

.step-progress {
  margin-right: 10px;
  margin-left: 10px;
  width: 300px;
  min-width: 150px; /* 或者其他足够显示进度条的最小宽度 */
}

.progress-container {
  display: flex;
  align-items: center;
}

.custom-button {
  background-color: rgb(245, 245, 245); /* 设置背景色为红色 */
  border-color: rgb(217, 217, 217); /* 设置边框颜色为红色，如果需要 */
  color: rgb(184, 184, 184); /* 设置边框颜色为红色，如果需要 */
}

.custom-button:hover {
  background-color: rgb(245, 245, 245); /* 鼠标悬停时保持相同的背景色 */
  border-color: rgb(217, 217, 217); /* 鼠标悬停时保持相同的边框颜色 */
  color: rgb(184, 184, 184); /* 鼠标悬停时保持相同的文字颜色 */
}

/* 当按钮可点击时应用的样式 */
.button-active {
  background-color: rgb(0, 154, 68); /* 设置背景为白色 */
  color: white; /* 可以调整文字颜色以保持可读性 */
  border-color: #dcdfe6; /* 可选：设置边框颜色 */
}

/* 悬停在 .button-active 上时的样式 */
.button-active:hover {
  color: white; /* 悬停时文字颜色为绿色 */
  border-color: rgb(0, 154, 68); /* 悬停时边框颜色为绿色 */
  background-color: rgb(0, 154, 68); /* 悬停时背景色为白色 */
}

.restart-test {
  text-align: left;
  margin: 0 0 10px 10px;
}

.anjian-detecting {
  color: blue; /* 蓝色表示检测中 */
  font-size: 14px;
}

.anjian-passed {
  color: rgb(0, 154, 68); /* 绿色表示通过 */
  font-weight: bold;
  font-size: 14px;
}

.anjian-failed {
  color: red; /* 红色表示不通过 */
  font-size: 14px;
}

.anjian-waiting {
  color: #A5A2A2; /* 暗色表示待检测 */
  font-size: 14px;
}

.button-icon {
  width: 30px;
  height: 30px;
  object-fit: contain; /* 保持图片比例 */
}

.button-item {
  margin-right: 5px;
}

.buttons-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* 如果按钮太多，需要换行排列 */
}

.button-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 5px;
}

.arrow-indicator {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
  pointer-events: none;
}

.arrow-text {
  background-color: #409EFF;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 20px;
  white-space: nowrap;
  margin-bottom: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #409EFF;
}

.top-distance {
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* 开始时旋转角度 */
  }
  100% {
    transform: rotate(360deg); /* 结束时旋转角度 */
  }
}

.right-distance {
  margin-right: 40px;
}

.test-num {
  color: #000000D9;
  font-size: 30px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  margin: 0 16px 0 0;
}

.test-feedback-container {
  display: flex;
  flex-direction: column;
}

.passed {
  color: #009A44;
  font-size: 30px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.failed {
  color: red;
  font-size: 30px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.num-result {
  display: flex;
  justify-content: center; /* 确保子元素之间的间距均匀分布 */

}

.align-num-res {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.test-content {
  color: #A5A2A2;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  margin: 0 0 16px;
}

.test-title {
  color: #A5A2A2;
  font-size: 18px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.main-title {
  color: #000000D9;
  font-size: 26px;
  font-family: "Pingfang sC", serif;
  margin: 10px 0 50px;
}

.progress-bar-container {
  width: 80%;
  margin: 0 auto;
}

.step-same-height {
  border: 1px solid rgba(196, 196, 196, 0.325); /* 加上透明色的边框 */
  border-radius: 8px; /* 可选：为边框添加圆角效果 */
}

/* 调整动态测试内容区域的背景颜色和内边距 */
.dynamic-test-content {
  background-color: white; /* 背景颜色设置为白色 */
  padding: 0; /* 调整内边距大小，根据需要自行调整 */
}

/* 设备盒子样式，包括边框和内边距 */
.device-connection {
  border: 2px solid #DDD; /* 添加2像素的黑色边框，可以根据需要调整颜色和边框宽度 */
  min-height: 400px; /* 最小高度 */
  height: auto; /* 高度自适应 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  overflow-y: auto; /* 超出时显示滚动条 */
}

.checkbox-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.test-step-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 300px;
  padding: 20px;
}

.img-size {
  width: 300px; /* 固定宽度为300px */
  height: 230px; /* 固定高度为230px */
  object-fit: contain; /* 保持图片比例并适应容器 */
}

.bg-progress {
  display: flex;
  align-items: center;
  background-color: rgb(245, 245, 245);
  height: 50px;
}

.progress-width {
  width: 30%;
}

</style>